"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESUME_OVALUE = exports.RESUME_QVALUE = exports.ICON_OPTION_VALUE_PREFIX = exports.DEVICE_OPTION_VALUE_PREFIX = exports.LANGUAGE_OPTION_VALUE_PREFIX = exports.CTA_QVALUE = exports.QUALITY_SCORE_QVALUE = exports.URL_METADATA_QUESTION_VALUE = exports.PANEL_QVALUE = exports.DEVICE_TYPE_QVALUE = exports.QUOTA_GROUP_QVALUE = exports.LANGUAGE_QVALUE = exports.SECURITY_QVALUE = exports.TERMINATE_QVALUE = exports.QUOTA_QVALUE = exports.COMPLETE_QVALUE = exports.BUILT_IN_OPTION_VALUE = exports.BUILTIN_OPTION_ID = exports.BUILTIN_QUESTION_ID = exports.QUOTA_TABLE_CSS = exports.DISQUALIFICATION_SCORE = exports.NLP_API_REQUEST_OPTS = exports.NLP_API_TIMEOUT = exports.DEFAULT_SESSION_STATE = exports.DEFAULT_CONVERSATION_CONTEXT = exports.MAX_LUIS_PROBES = exports.ENGLISH = exports.SPEED_PARAMETERS = exports.BOT_SPEEDS = exports.MONITOR_POLL_INTERVAL = exports.MIN_PAGELOADER_DURATION = exports.MAX_SAMPLE_SIZE = exports.NEXXT_EMAIL_DOMAIN = exports.INCA_DEMO_BOOK_URL = exports.INCA_HELP_URLS = exports.INCA_LOGO_URL = exports.STATIC_STORAGE_URL = exports.DEFAULT_REDIRECT_MSG = exports.DEFAULT_REDIRECT_URL = exports.RAPID_SOLUTION_ORDER = exports.RAPID_SOLUTION_NAMES = exports.RAPID_SOLUTION_IDS = exports.PROJECT_TEMPLATE_CODES = exports.PROJECT_CODENAMES = exports.ACCESS_INVALIDATION_STATUSES = exports.TEST = exports.MAX_UPLOAD_SIZE_BYTES = exports.MAX_UPLOAD_STR = exports.MAX_UPLOAD_MB = exports.PROD_DOMAIN = void 0;
exports.DATA_API_CACHE_TTL = exports.DYNAMIC_TEXT_REFERENCE_TAG = exports.KEY_NAME = exports.COLOR_THEME = exports.INCA_LOGO_WHITE = exports.LANGUAGES = exports.languageMapping = exports.DEFAULT_LANGUAGE = exports.NON_CASING_LANGUAGE_VALUES = exports.projectLanguage = exports.iconURLs = exports.ICON_OPTION_VALUE = exports.CUSTOM_QUESTION_IDENTIFIER = exports.CUSTOM_OPTION_IDENTIFIER = exports.EXTRACT_VECTOR_MAP_REGION_ID = exports.FILTER_VECTOR_MAP_CODES = exports.VECTOR_MAP_REGION_CODES = exports.DYNATA_VMAP_MAPPING = exports.VECTOR_MAP_LIST = exports.CANADA_PROVINCE_OPTION_IDS = exports.VECTOR_MAP_ENGLISH_TO_FRENCH = exports.VECTOR_MAP_ENGLISH_TO_CHINESE = exports.SESSION_ID_KEY = exports.BOT_THEME_LIST = exports.EXPORT_SYSTEM_DATA = exports.FRIENDLY_OPTION_VALUE = exports.LANGUAGE_VALUE = exports.QUOTA_STATUS_VALUE = exports.USER_AGENT_VALUE = exports.QUALITY_SCORE_VALUE = exports.DEVICE_TYPE_VALUE = exports.QUOTA_GROUP_VALUE = exports.PANEL_SOURCE_VALUE = exports.NO_OPTION = exports.NO_OPTION_VALUE = exports.YES_OPTION = exports.YES_OPTION_VALUE = exports.OTHER_OPTION = exports.NA_OPTION = exports.NUMERIC_AFTER_RANGE_VALUE = exports.NUMERIC_BEFORE_RANGE_VALUE = exports.OTHER_OPTION_VALUE = exports.OTHER_DEFAULT_TEXT = exports.NA_DEFAULT_TEXT = exports.NA_OPTION_VALUE = exports.CTA_DEMO_OVALUE = exports.DASHBOARD_OVALUE = exports.NPS_OVALUE = exports.VMAP_OVALUE = exports.RESTART_OVALUE = void 0;
exports.AWS_POLLY_AVATARS = exports.DEEPGRAM_AVATARS = exports.HEYGEN_AVATARS = exports.TRADE_OFF_TEXT_BASED_OPTION_CARD = exports.SVC_EVENT_NAME = exports.SVC_NAMESPACE_TYPE = exports.SVC_EVENT_TYPE = exports.MAX_DEMERIT_POINTS_OPTIONS = exports.RESEARCH_DOMAIN_OPTIONS = exports.NETCODE_SENTIMENT = exports.RANK_ORDER_OPTIONS = exports.TRADE_OFF_OPTIONS = exports.NPS_CATEGORY_TITLE = exports.NPS_SCORE_TITLE = exports.NPS_CATEGORY_VALUES = exports.NETCODE_UNCATEGORIZED = exports.SPECIAL_LABELS_MAPPING = exports.SPECIAL_KEY_UNCATEGORIZED = exports.SPECIAL_LABEL_OUTLIER = exports.DEFAULT_DISCOURSE_POLICY = exports.DEFAULT_VIDEOJS_OPTIONS = exports.NPS_BUTTONS = exports.ANNOTATION_BUTTONS_WITH_TEXT = exports.TRADEOFF_BUTTONS = exports.ANNOTATION_BUTTONS = exports.SECOND_IN_MILLISECOND = exports.TEXT_HIGHLIGHTER_OPTS = exports.PACKAGED_SOLUTION_QIDS = exports.GREETING_TEXT = exports.GREETING_IMAGE = exports.ALL = exports.STATUS = exports.CLIENT_ID = exports.ACCESS_TYPE = exports.PROJECT_MANAGER = exports.ACCOUNT_MANAGER = exports.HAS_AVATAR_ACCESS = exports.HAS_VOICE_PLUS_ACCESS = exports.AVAILABLE_PROJECTS = exports.TENANT_LEVEL_KEY = exports.TENANT_URL = exports.TENANT_NAME = exports.TENANT_ID = exports.USER_DETAILS = exports.PROFILE_PICTURE = exports.FILENAME_VALIDATE_REGEX = exports.URL_VALIDATE_REGEX = exports.DEFAULT_REDIRECT = exports.DEFAULT_GREETING = exports.REQUEST_DATA_TTL = void 0;
exports.SENSORY_BOT_PROJECT_ID = exports.SENSORY_BOT_POLICY_ID = exports.CODE_FILE_UPLOAD_PREFIX = exports.PERMISSIONS = exports.ACCOUNT_TYPES = exports.ROLES = exports.DEFAULT_QUESTION_INPUT_SETTINGS = exports.DEFAULT_EXPORT_SETTINGS = exports.DEFAULT_INPUT_SETTINGS = exports.DEEPGRAM_TRANSCRIPTION_LANGUAGES = exports.GOOGLE_TRANSCRIPTION_LANGUAGES = void 0;
var _ = require("lodash");
var uuid = require("uuid");
var TextService_1 = require("./services/TextService");
var types_1 = require("./types");
exports.PROD_DOMAIN = 'nexxt.in';
// FILE UPLOAD CONSTANTS
exports.MAX_UPLOAD_MB = 500;
exports.MAX_UPLOAD_STR = "".concat(exports.MAX_UPLOAD_MB, "mb");
exports.MAX_UPLOAD_SIZE_BYTES = exports.MAX_UPLOAD_MB * 1048576;
exports.TEST = 'TEST_VALUE_HERE';
/**
 * Statuses which determine that a respondent has 'finished' their chatbot session,
 * and as such may be prevented from accessing the chatbot again. These are distinguished
 * from statuses which indicate that user may still access (i.e. if they are still live
 * or have temporarily dropped out).
 */
exports.ACCESS_INVALIDATION_STATUSES = [
    types_1.QUOTA_STATUS.COMPLETE,
    types_1.QUOTA_STATUS.TERMINATE,
    types_1.QUOTA_STATUS.QUOTA_FULL,
    types_1.QUOTA_STATUS.SECURITY
];
// PROJECT CONSTANTS
exports.PROJECT_CODENAMES = {
    general: 821,
    ux: 823,
    cx: 834
};
var PROJECT_TEMPLATE_CODES;
(function (PROJECT_TEMPLATE_CODES) {
    PROJECT_TEMPLATE_CODES["RBC_COPY_TEST"] = "rbc-copy-test";
    PROJECT_TEMPLATE_CODES["RBC_VIDEO_TEST"] = "rbc-video-test";
    PROJECT_TEMPLATE_CODES["RAPID_VIDEO_AD_TEST"] = "RAPIDSOLUTION:VideoAnnotationDemoxwir";
    PROJECT_TEMPLATE_CODES["RAPID_COPY_TEST"] = "RAPIDSOLUTION:CopyTestDio5";
    PROJECT_TEMPLATE_CODES["RAPID_IMAGE_TEST"] = "RAPIDSOLUTION:ImageTest";
    PROJECT_TEMPLATE_CODES["VIDEO_TEST"] = "video-test";
    PROJECT_TEMPLATE_CODES["IDEA_SCREENING"] = "ideation-test";
    PROJECT_TEMPLATE_CODES["IMAGE_TEST"] = "image-test";
})(PROJECT_TEMPLATE_CODES = exports.PROJECT_TEMPLATE_CODES || (exports.PROJECT_TEMPLATE_CODES = {}));
var RAPID_SOLUTION_IDS;
(function (RAPID_SOLUTION_IDS) {
    RAPID_SOLUTION_IDS["RAPID_VIDEO_AD_TEST"] = "1";
    RAPID_SOLUTION_IDS["RAPID_COPY_TEST"] = "2";
    RAPID_SOLUTION_IDS["RAPID_IMAGE_TEST"] = "3";
})(RAPID_SOLUTION_IDS = exports.RAPID_SOLUTION_IDS || (exports.RAPID_SOLUTION_IDS = {}));
var RAPID_SOLUTION_NAMES;
(function (RAPID_SOLUTION_NAMES) {
    RAPID_SOLUTION_NAMES["RAPID_VIDEO_AD_TEST"] = "Video Ad Test";
    RAPID_SOLUTION_NAMES["RAPID_COPY_TEST"] = "Copy Test";
    RAPID_SOLUTION_NAMES["RAPID_IMAGE_TEST"] = "Image Ad Test";
})(RAPID_SOLUTION_NAMES = exports.RAPID_SOLUTION_NAMES || (exports.RAPID_SOLUTION_NAMES = {}));
exports.RAPID_SOLUTION_ORDER = [
    RAPID_SOLUTION_IDS.RAPID_VIDEO_AD_TEST,
    RAPID_SOLUTION_IDS.RAPID_COPY_TEST,
    RAPID_SOLUTION_IDS.RAPID_IMAGE_TEST
];
exports.DEFAULT_REDIRECT_URL = 'https://nexxt.in';
exports.DEFAULT_REDIRECT_MSG = 'This chat is no longer available. Please try a different link.';
exports.STATIC_STORAGE_URL = process.env.S3_STATIC_URL ||
    'https://nexxt-inca-storage.s3.us-east-2.amazonaws.com';
// INCA DEFAULTS
exports.INCA_LOGO_URL = "".concat(exports.STATIC_STORAGE_URL, "/img/inca_black.png");
exports.INCA_HELP_URLS = {
    // keys are tenantLevels; if not present use default!
    2: "".concat(exports.STATIC_STORAGE_URL, "/doc/RBC+Enterprise+-+inca+support.pdf"),
    DEFAULT: 'https://nexxtintelligence.freshdesk.com/'
};
exports.INCA_DEMO_BOOK_URL = 'https://nexxt.in/demo';
exports.NEXXT_EMAIL_DOMAIN = '@nexxt.in';
exports.MAX_SAMPLE_SIZE = 3000;
// SPEED-RELATED CONSTANTS
exports.MIN_PAGELOADER_DURATION = 1000; // in ms
exports.MONITOR_POLL_INTERVAL = 10000; // in ms
exports.BOT_SPEEDS = {
    slowest: 1.5,
    slow: 1.25,
    normal: 1,
    fast: 0.75,
    fastest: 0.5
};
exports.SPEED_PARAMETERS = {
    plainTextCPM: 550 * 5,
    richTextCPM: 550 * 5,
    questionTypingDelay: 2000,
    nonTextTypingDelay: 0,
    nonTextWaitingDelay: 0,
    longTypingThreshold: 100,
    longTypingDelay: 2500,
    shortTypingDelay: 700 // ms to wait for a SHORT typing event
};
// LANGUAGE-RELATED CONSTANTS
exports.ENGLISH = 'en';
// NLP CONFIG
exports.MAX_LUIS_PROBES = 2; // # of times bot will prompt user before giving up
exports.DEFAULT_CONVERSATION_CONTEXT = {
    numLazyAnswers: 0,
    numGibberishAnswers: 0,
    // probedTargetLabels: [],
    detectedTargetProbeCounts: {},
    mentionedEntities: [],
    oeAnswerFlow: {},
    oeAnswerScore: 0,
    contents: [],
    guidedFantasyProbes: []
};
exports.DEFAULT_SESSION_STATE = {
    sessionId: '0',
    status: types_1.QUOTA_STATUS.LIVE,
    redirectURL: '',
    messages: [],
    answers: [],
    langId: 'en',
    currentFlowValue: '-1',
    flowHistory: (_a = {}, _a[0] = '-1', _a),
    computedNextFlowValue: null,
    convo: exports.DEFAULT_CONVERSATION_CONTEXT,
    respondentId: -1,
    ceAnswerScore: 0,
    oeAnswerScore: 0,
    quotaGroup: null,
    panelQueryParams: {},
    testMode: false,
    groupStack: null,
    previousFlow: {
        question: null,
        answer: null,
        editEnable: false
    },
    currentParentValue: 0,
    generatedQuestions: {},
    lastClientSent: new Date().toJSON(),
    dialogues: {}
};
exports.NLP_API_TIMEOUT = 5000;
exports.NLP_API_REQUEST_OPTS = {
    timeout: exports.NLP_API_TIMEOUT
};
exports.DISQUALIFICATION_SCORE = (_b = {},
    _b["STRICT" /* STRICT */] = 5,
    _b["NORMAL" /* NORMAL */] = 10,
    _b);
// QUOTA TABLE STUFF
exports.QUOTA_TABLE_CSS = "<style>\n  .red { color: red; }\n  table {\n    border: solid 1px #DDEEEE;\n    border-collapse: collapse;\n    border-spacing: 0;\n    font: normal 13px Arial, sans-serif;\n  }\n  table thead th {\n      background-color: #DDEFEF;\n      border: solid 1px #DDEEEE;\n      color: #336B6B;\n      padding: 10px;\n      text-align: left;\n      text-shadow: 1px 1px 1px #fff;\n  }\n  table tbody td {\n      border: solid 1px #DDEEEE;\n      color: #333;\n      padding: 10px;\n      text-shadow: 1px 1px 1px #fff;\n    }\n</style>";
// SPECIAL QUESTION AND OPTION VALUES
exports.BUILTIN_QUESTION_ID = -1;
exports.BUILTIN_OPTION_ID = -1;
exports.BUILT_IN_OPTION_VALUE = '-1';
exports.COMPLETE_QVALUE = 'in.nexxt/qvalue/COMPLETE';
exports.QUOTA_QVALUE = 'in.nexxt/qvalue/QUOTA_FULL';
exports.TERMINATE_QVALUE = 'in.nexxt/qvalue/TERMINATE';
exports.SECURITY_QVALUE = 'in.nexxt/qvalue/SECURITY';
exports.LANGUAGE_QVALUE = 'in.nexxt/qvalue/LANGUAGE';
exports.QUOTA_GROUP_QVALUE = 'in.nexxt/qvalue/QUOTA_GROUP';
exports.DEVICE_TYPE_QVALUE = 'in.nexxt/qvalue/DEVICE_TYPE';
exports.PANEL_QVALUE = 'in.nexxt/qvalue/PANEL';
exports.URL_METADATA_QUESTION_VALUE = 'in.nexxt/qvalue/URL_METADATA';
exports.QUALITY_SCORE_QVALUE = 'in.nexxt/qvalue/QUALITY_SCORE';
exports.CTA_QVALUE = 'in.nexxt/qvalue/CTA';
exports.LANGUAGE_OPTION_VALUE_PREFIX = 'in.nexxt/ovalue/language/'; // must match the option values from portal
exports.DEVICE_OPTION_VALUE_PREFIX = 'in.nexxt/ovalue/device/';
exports.ICON_OPTION_VALUE_PREFIX = 'in.nexxt/ovalue/icon/';
exports.RESUME_QVALUE = 'in.nexxt/qvalue/RESUME';
exports.RESUME_OVALUE = 'in.nexxt/ovalue/RESUME';
exports.RESTART_OVALUE = 'in.nexxt/ovalue/RESTART';
exports.VMAP_OVALUE = 'in.nexxt/ovalue/vmap/';
exports.NPS_OVALUE = 'in.nexxt/ovalue/NPS';
exports.DASHBOARD_OVALUE = 'in.nexxt/ovalue/DASHBOARD';
exports.CTA_DEMO_OVALUE = 'in.nexxt/ovalue/DEMO';
exports.NA_OPTION_VALUE = 'in.nexxt/ovalue/NOTAPPLICABLE';
exports.NA_DEFAULT_TEXT = 'Not Applicable';
exports.OTHER_DEFAULT_TEXT = 'Other';
exports.OTHER_OPTION_VALUE = 'in.nexxt/ovalue/OTHER';
exports.NUMERIC_BEFORE_RANGE_VALUE = 'in.nexxt/ovalue/numeric/BEFORE_RANGE';
exports.NUMERIC_AFTER_RANGE_VALUE = 'in.nexxt/ovalue/numeric/AFTER_RANGE';
exports.NA_OPTION = {
    id: exports.BUILTIN_OPTION_ID,
    value: exports.NA_OPTION_VALUE,
    text: exports.NA_DEFAULT_TEXT,
    label: exports.NA_DEFAULT_TEXT
};
exports.OTHER_OPTION = {
    id: exports.BUILTIN_OPTION_ID,
    value: exports.OTHER_OPTION_VALUE,
    label: exports.OTHER_DEFAULT_TEXT,
    mediaURL: '',
    texts: []
};
exports.YES_OPTION_VALUE = 'in.nexxt/ovalue/YES';
exports.YES_OPTION = {
    id: exports.BUILTIN_OPTION_ID,
    value: exports.YES_OPTION_VALUE,
    texts: [
        {
            language: 'en',
            contents: [{ type: types_1.MULTIMEDIA_TYPES.TEXT, text: 'Yes' }]
        }
    ] // @TODO: i18n
};
exports.NO_OPTION_VALUE = 'in.nexxt/ovalue/NO';
exports.NO_OPTION = {
    id: exports.BUILTIN_OPTION_ID,
    value: exports.NO_OPTION_VALUE,
    texts: [
        {
            language: 'en',
            contents: [{ type: types_1.MULTIMEDIA_TYPES.TEXT, text: 'No' }]
        }
    ] // @TODO: i18n // @TODO: i18n
};
exports.PANEL_SOURCE_VALUE = 'Source';
exports.QUOTA_GROUP_VALUE = 'QuotaGroup';
exports.DEVICE_TYPE_VALUE = 'DeviceType';
exports.QUALITY_SCORE_VALUE = 'QualityScore';
exports.USER_AGENT_VALUE = 'UserAgent';
exports.QUOTA_STATUS_VALUE = 'Status';
exports.LANGUAGE_VALUE = 'Language';
exports.FRIENDLY_OPTION_VALUE = (_c = {},
    _c[exports.NA_OPTION_VALUE] = 999,
    _c[exports.OTHER_OPTION_VALUE] = 888,
    _c);
exports.EXPORT_SYSTEM_DATA = [
    {
        text: 'Respondent ID',
        value: 'RespondentID'
    },
    {
        text: 'Tracker ID',
        value: 'TrackerID'
    },
    {
        text: exports.PANEL_SOURCE_VALUE,
        value: exports.PANEL_SOURCE_VALUE
    },
    {
        text: 'Register Date',
        value: 'RegDate'
    },
    {
        text: 'IP Address',
        value: 'IP'
    },
    {
        text: exports.USER_AGENT_VALUE,
        value: exports.USER_AGENT_VALUE
    },
    {
        text: exports.DEVICE_TYPE_VALUE,
        value: exports.DEVICE_TYPE_VALUE
    },
    {
        text: exports.QUALITY_SCORE_VALUE,
        value: exports.QUALITY_SCORE_VALUE
    },
    {
        text: exports.QUOTA_STATUS_VALUE,
        value: exports.QUOTA_STATUS_VALUE
    },
    {
        text: 'Last Question Label',
        value: 'LastQuestionLabel'
    },
    {
        text: 'Last Respondent Date',
        value: 'LastRespDate'
    },
    {
        text: 'Duration',
        value: 'Duration'
    },
    {
        text: exports.LANGUAGE_VALUE,
        value: exports.LANGUAGE_VALUE
    }
];
/*
 * These are the available bot themes that the user can choose from.
 * The value should match the
 */
exports.BOT_THEME_LIST = [
    {
        id: 1,
        label: 'Purple Sky',
        value: 'purple_sky',
        image: "".concat(exports.STATIC_STORAGE_URL, "/img/portal/themes/purple_sky.png")
    },
    {
        id: 2,
        label: 'White',
        value: 'white',
        image: "".concat(exports.STATIC_STORAGE_URL, "/img/portal/themes/white.png")
    },
    {
        id: 3,
        label: 'Gradients',
        value: 'gradients',
        image: "".concat(exports.STATIC_STORAGE_URL, "/img/portal/themes/gradients.png")
    },
    {
        id: 4,
        label: 'Orange Clouds',
        value: 'orangeClouds',
        image: "".concat(exports.STATIC_STORAGE_URL, "/img/portal/themes/orange_clouds.png")
    },
    {
        id: 5,
        label: 'Floating Squares',
        value: 'floatingSquares',
        image: "".concat(exports.STATIC_STORAGE_URL, "/img/portal/themes/floating_squares.png")
    },
    {
        id: 6,
        label: 'Dots and Triangles',
        value: 'dotsAndTriangles',
        image: "".concat(exports.STATIC_STORAGE_URL, "/img/portal/themes/dots_and_triangles.png")
    },
    {
        id: 7,
        label: 'Custom',
        value: 'custom',
        image: "".concat(exports.STATIC_STORAGE_URL, "/img/portal/themes/white.png")
    }
];
// STORAGE KEY NAMES
exports.SESSION_ID_KEY = 'in.nexxt.bot/sessionId';
exports.VECTOR_MAP_ENGLISH_TO_CHINESE = {
    'CA-AB': '阿尔伯塔',
    'CA-BC': '卑诗省',
    'CA-MB': '马尼托巴',
    'CA-NB': '新不伦瑞克省',
    'CA-NL': '纽芬兰和拉布拉多',
    'CA-NS': '新斯科舍省',
    'CA-ON': '安大略',
    'CA-PE': '爱德华王子岛',
    'CA-QC': '魁北克',
    'CA-SK': '萨斯喀彻温省',
    'CA-NT': '西北地区',
    'CA-NU': '努纳武特',
    'CA-YT': '育空'
};
exports.VECTOR_MAP_ENGLISH_TO_FRENCH = {
    'CA-NT': 'Les Territoires du Nord-Ouest',
    'CA-NU': 'Le Nunavut',
    'CA-NS': 'La Nouvelle-Écosse',
    'CA-BC': 'La Colombie-Britannique',
    'CA-SK': 'La Saskatchewan',
    'CA-PE': 'Île-du-Prince-Édouard	',
    'CA-MB': 'Le Manitoba',
    'CA-YT': 'Le Yukon',
    'CA-NB': 'Le Nouveau-Brunswick',
    'CA-NL': 'La Terre-Neuve-et-Labrador',
    'CA-ON': "L'Ontario",
    'CA-AB': "L'Alberta",
    'CA-QC': 'Le Québec'
};
exports.CANADA_PROVINCE_OPTION_IDS = {
    // TODO: reserve unique option IDs for vector map!
    'Northwest Territories': 1,
    Nunavut: 2,
    'Nova Scotia': 3,
    'British Columbia': 4,
    Saskatchewan: 5,
    'Prince Edward Island': 6,
    Manitoba: 7,
    Yukon: 8,
    'New Brunswick': 9,
    'Newfoundland and Labrador': 10,
    Ontario: 11,
    Alberta: 12,
    Quebec: 13
};
exports.VECTOR_MAP_LIST = [
    // mapping from region selected on portal --> jvectormap map code on bot
    // see http://jvectormap.com/maps/world/
    {
        title: 'World Map (Countries)',
        label: 'World Map (Countries)',
        id: "world_mill" /* WORLD_MAP */,
        value: "world_mill" /* WORLD_MAP */,
        identifier: 'W'
    },
    {
        title: 'Canada',
        label: 'Canada',
        id: 'ca_lcc',
        value: 'ca_lcc',
        identifier: 'CA'
    },
    {
        title: 'USA',
        label: 'USA',
        id: 'us_aea',
        value: 'us_aea',
        identifier: 'US'
    },
    // {
    //     title: 'United Kingdom',
    //     label: 'United Kingdom',
    //     id: 'uk_regions_mill',
    //     value: 'uk_regions_mill',
    //     identifier: 'GB'
    // },
    // {
    //     title: "World Map (Continents)",
    //     label: "World Map (Continents)",
    //     id: "continents_mill",
    //     value: "continents_mill",
    // },
    {
        title: 'Africa',
        label: 'Africa',
        id: 'africa_mill',
        value: 'africa_mill',
        identifier: 'AF'
    },
    {
        title: 'Asia',
        label: 'Asia',
        id: 'asia_mill',
        value: 'asia_mill',
        identifier: 'AS'
    },
    {
        title: 'Europe',
        label: 'Europe',
        id: 'europe_mill',
        value: 'europe_mill',
        identifier: 'EU'
    },
    {
        title: 'North America',
        label: 'North America',
        id: 'north_america_mill',
        value: 'north_america_mill',
        identifier: 'NA'
    },
    {
        title: 'Oceania',
        label: 'Oceania',
        id: 'oceania_mill',
        value: 'oceania_mill',
        identifier: 'OC'
    },
    {
        title: 'South America',
        label: 'South America',
        id: 'south_america_mill',
        value: 'south_america_mill',
        identifier: 'SA'
    },
    {
        title: 'Argentina',
        label: 'Argentina',
        id: 'ar_mill',
        value: 'ar_mill',
        identifier: 'AR'
    },
    {
        title: 'India',
        label: 'India',
        id: 'in_mill',
        value: 'in_mill',
        identifier: 'IN'
    },
    {
        title: 'Brazil',
        label: 'Brazil',
        id: 'brazil',
        value: 'brazil',
        identifier: 'BR'
    }
    // {
    //     title: "France",
    //     label: "France",
    //     id: "fr_mill",
    //     value: "fr_mill",
    // },
    // {
    //     title: "Germany",
    //     label: "Germany",
    //     id: "de_mill",
    //     value: "de_mill",
    // },
    // {
    //     title: "Spain",
    //     label: "Spain",
    //     id: "es_mill",
    //     value: "es_mill",
    // },
    // {
    //     title: "Sweden",
    //     label: "Sweden",
    //     id: "se_mill",
    //     value: "se_mill",
    // },
    // {
    //     title: "Switzerland",
    //     label: "Switzerland",
    //     id: "ch_mill",
    //     value: "ch_mill",
    // },
    // {
    //     title: "Thailand",
    //     label: "Thailand",
    //     id: "th_mill",
    //     value: "th_mill",
    // },
];
exports.DYNATA_VMAP_MAPPING = {
    // CANADA
    'in.nexxt/ovalue/vmap/CA/CA-NT': '63',
    'in.nexxt/ovalue/vmap/CA/CA-NU': '64',
    'in.nexxt/ovalue/vmap/CA/CA-NS': '54',
    'in.nexxt/ovalue/vmap/CA/CA-BC': '61',
    'in.nexxt/ovalue/vmap/CA/CA-SK': '59',
    'in.nexxt/ovalue/vmap/CA/CA-PE': '53',
    'in.nexxt/ovalue/vmap/CA/CA-MB': '58',
    'in.nexxt/ovalue/vmap/CA/CA-YT': '62',
    'in.nexxt/ovalue/vmap/CA/CA-NB': '55',
    'in.nexxt/ovalue/vmap/CA/CA-NL': '52',
    'in.nexxt/ovalue/vmap/CA/CA-ON': '57',
    'in.nexxt/ovalue/vmap/CA/CA-AB': '60',
    'in.nexxt/ovalue/vmap/CA/CA-QC': '56',
    // US
    'in.nexxt/ovalue/vmap/US/US-VA': '51',
    'in.nexxt/ovalue/vmap/US/US-PA': '42',
    'in.nexxt/ovalue/vmap/US/US-TN': '47',
    'in.nexxt/ovalue/vmap/US/US-WV': '54',
    'in.nexxt/ovalue/vmap/US/US-NV': '32',
    'in.nexxt/ovalue/vmap/US/US-TX': '48',
    'in.nexxt/ovalue/vmap/US/US-NH': '33',
    'in.nexxt/ovalue/vmap/US/US-NY': '36',
    'in.nexxt/ovalue/vmap/US/US-HI': '15',
    'in.nexxt/ovalue/vmap/US/US-VT': '50',
    'in.nexxt/ovalue/vmap/US/US-NM': '35',
    'in.nexxt/ovalue/vmap/US/US-NC': '37',
    'in.nexxt/ovalue/vmap/US/US-ND': '38',
    'in.nexxt/ovalue/vmap/US/US-NE': '31',
    'in.nexxt/ovalue/vmap/US/US-LA': '22',
    'in.nexxt/ovalue/vmap/US/US-SD': '46',
    'in.nexxt/ovalue/vmap/US/US-DC': '11',
    'in.nexxt/ovalue/vmap/US/US-DE': '10',
    'in.nexxt/ovalue/vmap/US/US-FL': '12',
    'in.nexxt/ovalue/vmap/US/US-CT': '9',
    'in.nexxt/ovalue/vmap/US/US-WA': '53',
    'in.nexxt/ovalue/vmap/US/US-KS': '20',
    'in.nexxt/ovalue/vmap/US/US-WI': '55',
    'in.nexxt/ovalue/vmap/US/US-OR': '41',
    'in.nexxt/ovalue/vmap/US/US-KY': '21',
    'in.nexxt/ovalue/vmap/US/US-ME': '23',
    'in.nexxt/ovalue/vmap/US/US-OH': '39',
    'in.nexxt/ovalue/vmap/US/US-OK': '40',
    'in.nexxt/ovalue/vmap/US/US-ID': '16',
    'in.nexxt/ovalue/vmap/US/US-WY': '56',
    'in.nexxt/ovalue/vmap/US/US-UT': '49',
    'in.nexxt/ovalue/vmap/US/US-IN': '18',
    'in.nexxt/ovalue/vmap/US/US-IL': '17',
    'in.nexxt/ovalue/vmap/US/US-AK': '2',
    'in.nexxt/ovalue/vmap/US/US-NJ': '34',
    'in.nexxt/ovalue/vmap/US/US-CO': '8',
    'in.nexxt/ovalue/vmap/US/US-MD': '24',
    'in.nexxt/ovalue/vmap/US/US-MA': '25',
    'in.nexxt/ovalue/vmap/US/US-AL': '1',
    'in.nexxt/ovalue/vmap/US/US-MO': '29',
    'in.nexxt/ovalue/vmap/US/US-MN': '27',
    'in.nexxt/ovalue/vmap/US/US-CA': '6',
    'in.nexxt/ovalue/vmap/US/US-IA': '19',
    'in.nexxt/ovalue/vmap/US/US-MI': '26',
    'in.nexxt/ovalue/vmap/US/US-GA': '13',
    'in.nexxt/ovalue/vmap/US/US-AZ': '4',
    'in.nexxt/ovalue/vmap/US/US-MT': '30',
    'in.nexxt/ovalue/vmap/US/US-MS': '28',
    'in.nexxt/ovalue/vmap/US/US-SC': '45',
    'in.nexxt/ovalue/vmap/US/US-RI': '44',
    'in.nexxt/ovalue/vmap/US/US-AR': '5'
    // UK
    // 'in.nexxt/ovalue/vmap/GB/UKF': '1',
    // 'in.nexxt/ovalue/vmap/GB/WLS': '10 ',
    // 'in.nexxt/ovalue/vmap/GB/NIR': '6',
    // 'in.nexxt/ovalue/vmap/GB/UKK': '9',
    // 'in.nexxt/ovalue/vmap/GB/UKJ': '8',
    // 'in.nexxt/ovalue/vmap/GB/UKI': '3',
    // 'in.nexxt/ovalue/vmap/GB/UKH': '2',
    // 'in.nexxt/ovalue/vmap/GB/UKG': '11',
    // 'in.nexxt/ovalue/vmap/GB/SCT': '7',
    // 'in.nexxt/ovalue/vmap/GB/UKE': '12',
    // 'in.nexxt/ovalue/vmap/GB/UKD': '5',
    // 'in.nexxt/ovalue/vmap/GB/UKC': '4'
};
exports.VECTOR_MAP_REGION_CODES = {
    // CANADA
    'in.nexxt/ovalue/vmap/CA/CA-NT': 'Northwest Territories',
    'in.nexxt/ovalue/vmap/CA/CA-NU': 'Nunavut',
    'in.nexxt/ovalue/vmap/CA/CA-NS': 'Nova Scotia',
    'in.nexxt/ovalue/vmap/CA/CA-BC': 'British Columbia',
    'in.nexxt/ovalue/vmap/CA/CA-SK': 'Saskatchewan',
    'in.nexxt/ovalue/vmap/CA/CA-PE': 'Prince Edward Island',
    'in.nexxt/ovalue/vmap/CA/CA-MB': 'Manitoba',
    'in.nexxt/ovalue/vmap/CA/CA-YT': 'Yukon',
    'in.nexxt/ovalue/vmap/CA/CA-NB': 'New Brunswick',
    'in.nexxt/ovalue/vmap/CA/CA-NL': 'Newfoundland and Labrador',
    'in.nexxt/ovalue/vmap/CA/CA-ON': 'Ontario',
    'in.nexxt/ovalue/vmap/CA/CA-AB': 'Alberta',
    'in.nexxt/ovalue/vmap/CA/CA-QC': 'Quebec',
    // UNITED STATES
    'in.nexxt/ovalue/vmap/US/US-VA': 'Virginia',
    'in.nexxt/ovalue/vmap/US/US-PA': 'Pennsylvania',
    'in.nexxt/ovalue/vmap/US/US-TN': 'Tennessee',
    'in.nexxt/ovalue/vmap/US/US-WV': 'West Virginia',
    'in.nexxt/ovalue/vmap/US/US-NV': 'Nevada',
    'in.nexxt/ovalue/vmap/US/US-TX': 'Texas',
    'in.nexxt/ovalue/vmap/US/US-NH': 'New Hampshire',
    'in.nexxt/ovalue/vmap/US/US-NY': 'New York',
    'in.nexxt/ovalue/vmap/US/US-HI': 'Hawaii',
    'in.nexxt/ovalue/vmap/US/US-VT': 'Vermont',
    'in.nexxt/ovalue/vmap/US/US-NM': 'New Mexico',
    'in.nexxt/ovalue/vmap/US/US-NC': 'North Carolina',
    'in.nexxt/ovalue/vmap/US/US-ND': 'North Dakota',
    'in.nexxt/ovalue/vmap/US/US-NE': 'Nebraska',
    'in.nexxt/ovalue/vmap/US/US-LA': 'Louisiana',
    'in.nexxt/ovalue/vmap/US/US-SD': 'South Dakota',
    'in.nexxt/ovalue/vmap/US/US-DC': 'District of Columbia',
    'in.nexxt/ovalue/vmap/US/US-DE': 'Delaware',
    'in.nexxt/ovalue/vmap/US/US-FL': 'Florida',
    'in.nexxt/ovalue/vmap/US/US-CT': 'Connecticut',
    'in.nexxt/ovalue/vmap/US/US-WA': 'Washington',
    'in.nexxt/ovalue/vmap/US/US-KS': 'Kansas',
    'in.nexxt/ovalue/vmap/US/US-WI': 'Wisconsin',
    'in.nexxt/ovalue/vmap/US/US-OR': 'Oregon',
    'in.nexxt/ovalue/vmap/US/US-KY': 'Kentucky',
    'in.nexxt/ovalue/vmap/US/US-ME': 'Maine',
    'in.nexxt/ovalue/vmap/US/US-OH': 'Ohio',
    'in.nexxt/ovalue/vmap/US/US-OK': 'Oklahoma',
    'in.nexxt/ovalue/vmap/US/US-ID': 'Idaho',
    'in.nexxt/ovalue/vmap/US/US-WY': 'Wyoming',
    'in.nexxt/ovalue/vmap/US/US-UT': 'Utah',
    'in.nexxt/ovalue/vmap/US/US-IN': 'Indiana',
    'in.nexxt/ovalue/vmap/US/US-IL': 'Illinois',
    'in.nexxt/ovalue/vmap/US/US-AK': 'Alaska',
    'in.nexxt/ovalue/vmap/US/US-NJ': 'New Jersey',
    'in.nexxt/ovalue/vmap/US/US-CO': 'Colorado',
    'in.nexxt/ovalue/vmap/US/US-MD': 'Maryland',
    'in.nexxt/ovalue/vmap/US/US-MA': 'Massachusetts',
    'in.nexxt/ovalue/vmap/US/US-AL': 'Alabama',
    'in.nexxt/ovalue/vmap/US/US-MO': 'Missouri',
    'in.nexxt/ovalue/vmap/US/US-MN': 'Minnesota',
    'in.nexxt/ovalue/vmap/US/US-CA': 'California',
    'in.nexxt/ovalue/vmap/US/US-IA': 'Iowa',
    'in.nexxt/ovalue/vmap/US/US-MI': 'Michigan',
    'in.nexxt/ovalue/vmap/US/US-GA': 'Georgia',
    'in.nexxt/ovalue/vmap/US/US-AZ': 'Arizona',
    'in.nexxt/ovalue/vmap/US/US-MT': 'Montana',
    'in.nexxt/ovalue/vmap/US/US-MS': 'Mississipi',
    'in.nexxt/ovalue/vmap/US/US-SC': 'South Carolina',
    'in.nexxt/ovalue/vmap/US/US-RI': 'Rhode Island',
    'in.nexxt/ovalue/vmap/US/US-AR': 'Arkansas',
    // UK
    // 'in.nexxt/ovalue/vmap/GB/UKF': 'East Midlands',
    // 'in.nexxt/ovalue/vmap/GB/WLS': 'Wales ',
    // 'in.nexxt/ovalue/vmap/GB/NIR': 'Northern Ireland',
    // 'in.nexxt/ovalue/vmap/GB/UKK': 'South West',
    // 'in.nexxt/ovalue/vmap/GB/UKJ': 'South East',
    // 'in.nexxt/ovalue/vmap/GB/UKI': 'London',
    // 'in.nexxt/ovalue/vmap/GB/UKH': 'East',
    // 'in.nexxt/ovalue/vmap/GB/UKG': 'West Midlands',
    // 'in.nexxt/ovalue/vmap/GB/SCT': 'Scotland',
    // 'in.nexxt/ovalue/vmap/GB/UKE': 'Yorkshire and the Humber',
    // 'in.nexxt/ovalue/vmap/GB/UKD': 'North West',
    // 'in.nexxt/ovalue/vmap/GB/UKC': 'North East',
    // ARGENTINA [ar_mill]
    'in.nexxt/ovalue/vmap/AR/AR-Z': 'Santa Cruz',
    'in.nexxt/ovalue/vmap/AR/AR-X': 'Córdoba',
    'in.nexxt/ovalue/vmap/AR/AR-Y': 'Jujuy',
    'in.nexxt/ovalue/vmap/AR/AR-V': 'Tierra del Fuego',
    'in.nexxt/ovalue/vmap/AR/AR-W': 'Corrientes',
    'in.nexxt/ovalue/vmap/AR/AR-T': 'Tucumán',
    'in.nexxt/ovalue/vmap/AR/AR-U': 'Chubut',
    'in.nexxt/ovalue/vmap/AR/AR-R': 'Río Negro',
    'in.nexxt/ovalue/vmap/AR/AR-S': 'Santa Fe',
    'in.nexxt/ovalue/vmap/AR/AR-P': 'Formosa',
    'in.nexxt/ovalue/vmap/AR/AR-Q': 'Neuquén',
    'in.nexxt/ovalue/vmap/AR/AR-N': 'Misiones',
    'in.nexxt/ovalue/vmap/AR/AR-L': 'La Pampa',
    'in.nexxt/ovalue/vmap/AR/AR-M': 'Mendoza',
    'in.nexxt/ovalue/vmap/AR/AR-J': 'San Juan',
    'in.nexxt/ovalue/vmap/AR/AR-K': 'Catamarca',
    'in.nexxt/ovalue/vmap/AR/AR-H': 'Chaco',
    'in.nexxt/ovalue/vmap/AR/AR-F': 'La Rioja',
    'in.nexxt/ovalue/vmap/AR/AR-G': 'Santiago del Estero',
    'in.nexxt/ovalue/vmap/AR/AR-D': 'San Luis',
    'in.nexxt/ovalue/vmap/AR/AR-E': 'Entre Rios',
    'in.nexxt/ovalue/vmap/AR/AR-B': 'Buenos Aires',
    'in.nexxt/ovalue/vmap/AR/AR-C': 'Ciudad de Buenos Aires',
    'in.nexxt/ovalue/vmap/AR/AR-A': 'Salta',
    // INDIA [in_mill]
    'in.nexxt/ovalue/vmap/IN/IN-BR': 'Bihar',
    'in.nexxt/ovalue/vmap/IN/IN-PY': 'Puducherry',
    'in.nexxt/ovalue/vmap/IN/IN-DD': 'Daman and Diu',
    'in.nexxt/ovalue/vmap/IN/IN-DN': 'Dadra and Nagar Haveli',
    'in.nexxt/ovalue/vmap/IN/IN-DL': 'Delhi',
    'in.nexxt/ovalue/vmap/IN/IN-NL': 'Nagaland',
    'in.nexxt/ovalue/vmap/IN/IN-WB': 'West Bengal',
    'in.nexxt/ovalue/vmap/IN/IN-HR': 'Haryana',
    'in.nexxt/ovalue/vmap/IN/IN-HP': 'Himachal Pradesh',
    'in.nexxt/ovalue/vmap/IN/IN-AS': 'Assam',
    'in.nexxt/ovalue/vmap/IN/IN-UT': 'Uttaranchal',
    'in.nexxt/ovalue/vmap/IN/IN-JH': 'Jharkhand',
    'in.nexxt/ovalue/vmap/IN/IN-JK': 'Jammu and Kashmir',
    'in.nexxt/ovalue/vmap/IN/IN-UP': 'Uttar Pradesh',
    'in.nexxt/ovalue/vmap/IN/IN-SK': 'Sikkim',
    'in.nexxt/ovalue/vmap/IN/IN-MZ': 'Mizoram',
    'in.nexxt/ovalue/vmap/IN/IN-CT': 'Chhattisgarh',
    'in.nexxt/ovalue/vmap/IN/IN-CH': 'Chandigarh',
    'in.nexxt/ovalue/vmap/IN/IN-GA': 'Goa',
    'in.nexxt/ovalue/vmap/IN/IN-GJ': 'Gujarat',
    'in.nexxt/ovalue/vmap/IN/IN-RJ': 'Rajasthan',
    'in.nexxt/ovalue/vmap/IN/IN-MP': 'Madhya Pradesh',
    'in.nexxt/ovalue/vmap/IN/IN-OR': 'Orissa',
    'in.nexxt/ovalue/vmap/IN/IN-TN': 'Tamil Nadu',
    'in.nexxt/ovalue/vmap/IN/IN-AN': 'Andaman and Nicobar',
    'in.nexxt/ovalue/vmap/IN/IN-AP': 'Andhra Pradesh',
    'in.nexxt/ovalue/vmap/IN/IN-TR': 'Tripura',
    'in.nexxt/ovalue/vmap/IN/IN-AR': 'Arunachal Pradesh',
    'in.nexxt/ovalue/vmap/IN/IN-KA': 'Karnataka',
    'in.nexxt/ovalue/vmap/IN/IN-PB': 'Punjab',
    'in.nexxt/ovalue/vmap/IN/IN-ML': 'Meghalaya',
    'in.nexxt/ovalue/vmap/IN/IN-MN': 'Manipur',
    'in.nexxt/ovalue/vmap/IN/IN-MH': 'Maharashtra',
    'in.nexxt/ovalue/vmap/IN/IN-KL': 'Kerala',
    // BRAZIL [brazil]
    'in.nexxt/ovalue/vmap/BR/ro': 'Rondônia',
    'in.nexxt/ovalue/vmap/BR/ac': 'Acre',
    'in.nexxt/ovalue/vmap/BR/am': 'Amazonas',
    'in.nexxt/ovalue/vmap/BR/rr': 'Rondônia',
    'in.nexxt/ovalue/vmap/BR/ap': 'Amapá',
    'in.nexxt/ovalue/vmap/BR/al': 'Alagoas',
    'in.nexxt/ovalue/vmap/BR/ba': 'Bahia',
    'in.nexxt/ovalue/vmap/BR/ce': 'Ceará',
    'in.nexxt/ovalue/vmap/BR/df': 'Distrito Federal',
    'in.nexxt/ovalue/vmap/BR/es': 'Espírito Santo',
    'in.nexxt/ovalue/vmap/BR/go': 'Goiás',
    'in.nexxt/ovalue/vmap/BR/ma': 'Maranhão',
    'in.nexxt/ovalue/vmap/BR/mt': 'Mato Grosso',
    'in.nexxt/ovalue/vmap/BR/ms': 'Mato Grosso do Sul',
    'in.nexxt/ovalue/vmap/BR/mg': 'Minas Gerais',
    'in.nexxt/ovalue/vmap/BR/pa': 'Pará',
    'in.nexxt/ovalue/vmap/BR/pb': 'Paraíba',
    'in.nexxt/ovalue/vmap/BR/pr': 'Paraná',
    'in.nexxt/ovalue/vmap/BR/pe': 'Pernambuco',
    'in.nexxt/ovalue/vmap/BR/pi': 'Piauí',
    'in.nexxt/ovalue/vmap/BR/rj': 'Rio de Janeiro',
    'in.nexxt/ovalue/vmap/BR/rn': 'Rio Grande do Norte',
    'in.nexxt/ovalue/vmap/BR/rs': 'Rio Grande do Sul',
    'in.nexxt/ovalue/vmap/BR/sc': 'Santa Catarina',
    'in.nexxt/ovalue/vmap/BR/sp': 'São Paulo',
    'in.nexxt/ovalue/vmap/BR/se': 'Sergipe',
    'in.nexxt/ovalue/vmap/BR/to': 'Tocantins',
    // WORLD MAP and CONTINENT MAPS
    // ASIA
    'in.nexxt/ovalue/vmap/W/BD': 'Bangladesh',
    'in.nexxt/ovalue/vmap/AS/BD': 'Bangladesh',
    'in.nexxt/ovalue/vmap/W/BN': 'Brunei',
    'in.nexxt/ovalue/vmap/AS/BN': 'Brunei',
    'in.nexxt/ovalue/vmap/W/JP': 'Japan',
    'in.nexxt/ovalue/vmap/AS/JP': 'Japan',
    'in.nexxt/ovalue/vmap/W/BT': 'Bhutan',
    'in.nexxt/ovalue/vmap/AS/BT': 'Bhutan',
    'in.nexxt/ovalue/vmap/W/TL': 'Timor-Leste',
    'in.nexxt/ovalue/vmap/AS/TL': 'Timor-Leste',
    'in.nexxt/ovalue/vmap/W/TM': 'Turkmenistan',
    'in.nexxt/ovalue/vmap/AS/TM': 'Turkmenistan',
    'in.nexxt/ovalue/vmap/W/TJ': 'Tajikistan',
    'in.nexxt/ovalue/vmap/AS/TJ': 'Tajikistan',
    'in.nexxt/ovalue/vmap/W/GE': 'Georgia',
    'in.nexxt/ovalue/vmap/AS/GE': 'Georgia',
    'in.nexxt/ovalue/vmap/W/OM': 'Oman',
    'in.nexxt/ovalue/vmap/AS/OM': 'Oman',
    'in.nexxt/ovalue/vmap/W/JO': 'Jordan',
    'in.nexxt/ovalue/vmap/AS/JO': 'Jordan',
    'in.nexxt/ovalue/vmap/W/PS': 'Palestine',
    'in.nexxt/ovalue/vmap/AS/PS': 'Palestine',
    'in.nexxt/ovalue/vmap/W/HK': 'Hong Kong',
    'in.nexxt/ovalue/vmap/AS/HK': 'Hong Kong',
    'in.nexxt/ovalue/vmap/W/PK': 'Pakistan',
    'in.nexxt/ovalue/vmap/AS/PK': 'Pakistan',
    'in.nexxt/ovalue/vmap/W/PH': 'Philippines',
    'in.nexxt/ovalue/vmap/AS/PH': 'Philippines',
    'in.nexxt/ovalue/vmap/W/VN': 'Vietnam',
    'in.nexxt/ovalue/vmap/AS/VN': 'Vietnam',
    'in.nexxt/ovalue/vmap/W/UZ': 'Uzbekistan',
    'in.nexxt/ovalue/vmap/AS/UZ': 'Uzbekistan',
    'in.nexxt/ovalue/vmap/W/MM': 'Myanmar',
    'in.nexxt/ovalue/vmap/AS/MM': 'Myanmar',
    'in.nexxt/ovalue/vmap/W/SG': 'Singapore',
    'in.nexxt/ovalue/vmap/AS/SG': 'Singapore',
    'in.nexxt/ovalue/vmap/W/MN': 'Mongolia',
    'in.nexxt/ovalue/vmap/AS/MN': 'Mongolia',
    'in.nexxt/ovalue/vmap/W/MY': 'Malaysia',
    'in.nexxt/ovalue/vmap/AS/MY': 'Malaysia',
    'in.nexxt/ovalue/vmap/W/IL': 'Israel',
    'in.nexxt/ovalue/vmap/AS/IL': 'Israel',
    'in.nexxt/ovalue/vmap/W/NP': 'Nepal',
    'in.nexxt/ovalue/vmap/AS/NP': 'Nepal',
    'in.nexxt/ovalue/vmap/W/CN': 'China',
    'in.nexxt/ovalue/vmap/AS/CN': 'China',
    'in.nexxt/ovalue/vmap/W/XC': 'N. Cyprus',
    'in.nexxt/ovalue/vmap/AS/XC': 'N. Cyprus',
    'in.nexxt/ovalue/vmap/W/CY': 'Cyprus',
    'in.nexxt/ovalue/vmap/AS/CY': 'Cyprus',
    'in.nexxt/ovalue/vmap/W/SY': 'Syria',
    'in.nexxt/ovalue/vmap/AS/SY': 'Syria',
    'in.nexxt/ovalue/vmap/W/KG': 'Kyrgyzstan',
    'in.nexxt/ovalue/vmap/AS/KG': 'Kyrgyzstan',
    'in.nexxt/ovalue/vmap/W/KH': 'Cambodia',
    'in.nexxt/ovalue/vmap/AS/KH': 'Cambodia',
    'in.nexxt/ovalue/vmap/W/KR': 'Korea',
    'in.nexxt/ovalue/vmap/AS/KR': 'Korea',
    'in.nexxt/ovalue/vmap/W/KP': 'Dem. Rep. Korea',
    'in.nexxt/ovalue/vmap/AS/KP': 'Dem. Rep. Korea',
    'in.nexxt/ovalue/vmap/W/KW': 'Kuwait',
    'in.nexxt/ovalue/vmap/AS/KW': 'Kuwait',
    'in.nexxt/ovalue/vmap/W/KZ': 'Kazakhstan',
    'in.nexxt/ovalue/vmap/AS/KZ': 'Kazakhstan',
    'in.nexxt/ovalue/vmap/W/YE': 'Yemen',
    'in.nexxt/ovalue/vmap/AS/YE': 'Yemen',
    'in.nexxt/ovalue/vmap/W/LB': 'Lebanon',
    'in.nexxt/ovalue/vmap/AS/LB': 'Lebanon',
    'in.nexxt/ovalue/vmap/W/LA': 'Lao PDR',
    'in.nexxt/ovalue/vmap/AS/LA': 'Lao PDR',
    'in.nexxt/ovalue/vmap/W/TW': 'Taiwan',
    'in.nexxt/ovalue/vmap/AS/TW': 'Taiwan',
    'in.nexxt/ovalue/vmap/W/TR': 'Turkey',
    'in.nexxt/ovalue/vmap/AS/TR': 'Turkey',
    'in.nexxt/ovalue/vmap/W/LK': 'Sri Lanka',
    'in.nexxt/ovalue/vmap/AS/LK': 'Sri Lanka',
    'in.nexxt/ovalue/vmap/W/TH': 'Thailand',
    'in.nexxt/ovalue/vmap/AS/TH': 'Thailand',
    'in.nexxt/ovalue/vmap/W/AE': 'United Arab Emirates',
    'in.nexxt/ovalue/vmap/AS/AE': 'United Arab Emirates',
    'in.nexxt/ovalue/vmap/W/AF': 'Afghanistan',
    'in.nexxt/ovalue/vmap/AS/AF': 'Afghanistan',
    'in.nexxt/ovalue/vmap/W/IQ': 'Iraq',
    'in.nexxt/ovalue/vmap/AS/IQ': 'Iraq',
    'in.nexxt/ovalue/vmap/W/IR': 'Iran',
    'in.nexxt/ovalue/vmap/AS/IR': 'Iran',
    'in.nexxt/ovalue/vmap/W/AM': 'Armenia',
    'in.nexxt/ovalue/vmap/AS/AM': 'Armenia',
    'in.nexxt/ovalue/vmap/W/IN': 'India',
    'in.nexxt/ovalue/vmap/AS/IN': 'India',
    'in.nexxt/ovalue/vmap/W/AZ': 'Azerbaijan',
    'in.nexxt/ovalue/vmap/AS/AZ': 'Azerbaijan',
    'in.nexxt/ovalue/vmap/W/ID': 'Indonesia',
    'in.nexxt/ovalue/vmap/AS/ID': 'Indonesia',
    'in.nexxt/ovalue/vmap/W/SA': 'Saudi Arabia',
    'in.nexxt/ovalue/vmap/AS/SA': 'Saudi Arabia',
    'in.nexxt/ovalue/vmap/W/QA': 'Qatar',
    'in.nexxt/ovalue/vmap/AS/QA': 'Qatar',
    // EUROPE
    'in.nexxt/ovalue/vmap/W/BE': 'Belgium',
    'in.nexxt/ovalue/vmap/EU/BE': 'Belgium',
    'in.nexxt/ovalue/vmap/W/BG': 'Bulgaria',
    'in.nexxt/ovalue/vmap/EU/BG': 'Bulgaria',
    'in.nexxt/ovalue/vmap/W/BA': 'Bosnia and Herz.',
    'in.nexxt/ovalue/vmap/EU/BA': 'Bosnia and Herz.',
    'in.nexxt/ovalue/vmap/W/BY': 'Belarus',
    'in.nexxt/ovalue/vmap/EU/BY': 'Belarus',
    'in.nexxt/ovalue/vmap/W/RU': 'Russia',
    'in.nexxt/ovalue/vmap/EU/RU': 'Russia',
    'in.nexxt/ovalue/vmap/W/RS': 'Serbia',
    'in.nexxt/ovalue/vmap/EU/RS': 'Serbia',
    'in.nexxt/ovalue/vmap/W/RO': 'Romania',
    'in.nexxt/ovalue/vmap/EU/RO': 'Romania',
    'in.nexxt/ovalue/vmap/W/GR': 'Greece',
    'in.nexxt/ovalue/vmap/EU/GR': 'Greece',
    'in.nexxt/ovalue/vmap/W/GB': 'United Kingdom',
    'in.nexxt/ovalue/vmap/EU/GB': 'United Kingdom',
    'in.nexxt/ovalue/vmap/W/HR': 'Croatia',
    'in.nexxt/ovalue/vmap/EU/HR': 'Croatia',
    'in.nexxt/ovalue/vmap/W/HU': 'Hungary',
    'in.nexxt/ovalue/vmap/EU/HU': 'Hungary',
    'in.nexxt/ovalue/vmap/W/PT': 'Portugal',
    'in.nexxt/ovalue/vmap/EU/PT': 'Portugal',
    'in.nexxt/ovalue/vmap/W/PL': 'Poland',
    'in.nexxt/ovalue/vmap/EU/PL': 'Poland',
    'in.nexxt/ovalue/vmap/W/EE': 'Estonia',
    'in.nexxt/ovalue/vmap/EU/EE': 'Estonia',
    'in.nexxt/ovalue/vmap/W/IT': 'Italy',
    'in.nexxt/ovalue/vmap/EU/IT': 'Italy',
    'in.nexxt/ovalue/vmap/W/ES': 'Spain',
    'in.nexxt/ovalue/vmap/EU/ES': 'Spain',
    'in.nexxt/ovalue/vmap/W/ME': 'Montenegro',
    'in.nexxt/ovalue/vmap/EU/ME': 'Montenegro',
    'in.nexxt/ovalue/vmap/W/MD': 'Moldova',
    'in.nexxt/ovalue/vmap/EU/MD': 'Moldova',
    'in.nexxt/ovalue/vmap/W/MK': 'Macedonia',
    'in.nexxt/ovalue/vmap/EU/MK': 'Macedonia',
    'in.nexxt/ovalue/vmap/W/FR': 'France',
    'in.nexxt/ovalue/vmap/EU/FR': 'France',
    'in.nexxt/ovalue/vmap/W/FI': 'Finland',
    'in.nexxt/ovalue/vmap/EU/FI': 'Finland',
    'in.nexxt/ovalue/vmap/W/NL': 'Netherlands',
    'in.nexxt/ovalue/vmap/EU/NL': 'Netherlands',
    'in.nexxt/ovalue/vmap/W/NO': 'Norway',
    'in.nexxt/ovalue/vmap/EU/NO': 'Norway',
    'in.nexxt/ovalue/vmap/W/XK': 'Kosovo',
    'in.nexxt/ovalue/vmap/EU/XK': 'Kosovo',
    'in.nexxt/ovalue/vmap/W/CH': 'Switzerland',
    'in.nexxt/ovalue/vmap/EU/CH': 'Switzerland',
    'in.nexxt/ovalue/vmap/W/CZ': 'Czech Rep.',
    'in.nexxt/ovalue/vmap/EU/CZ': 'Czech Rep.',
    'in.nexxt/ovalue/vmap/W/SK': 'Slovakia',
    'in.nexxt/ovalue/vmap/EU/SK': 'Slovakia',
    'in.nexxt/ovalue/vmap/W/SI': 'Slovenia',
    'in.nexxt/ovalue/vmap/EU/SI': 'Slovenia',
    'in.nexxt/ovalue/vmap/W/SE': 'Sweden',
    'in.nexxt/ovalue/vmap/EU/SE': 'Sweden',
    'in.nexxt/ovalue/vmap/W/DK': 'Denmark',
    'in.nexxt/ovalue/vmap/EU/DK': 'Denmark',
    'in.nexxt/ovalue/vmap/W/DE': 'Germany',
    'in.nexxt/ovalue/vmap/EU/DE': 'Germany',
    'in.nexxt/ovalue/vmap/W/LT': 'Lithuania',
    'in.nexxt/ovalue/vmap/EU/LT': 'Lithuania',
    'in.nexxt/ovalue/vmap/W/LU': 'Luxembourg',
    'in.nexxt/ovalue/vmap/EU/LU': 'Luxembourg',
    'in.nexxt/ovalue/vmap/W/IS': 'Iceland',
    'in.nexxt/ovalue/vmap/EU/IS': 'Iceland',
    'in.nexxt/ovalue/vmap/W/AL': 'Albania',
    'in.nexxt/ovalue/vmap/EU/AL': 'Albania',
    'in.nexxt/ovalue/vmap/W/AT': 'Austria',
    'in.nexxt/ovalue/vmap/EU/AT': 'Austria',
    'in.nexxt/ovalue/vmap/W/IE': 'Ireland',
    'in.nexxt/ovalue/vmap/EU/IE': 'Ireland',
    'in.nexxt/ovalue/vmap/W/UA': 'Ukraine',
    'in.nexxt/ovalue/vmap/EU/UA': 'Ukraine',
    'in.nexxt/ovalue/vmap/W/LV': 'Latvia',
    'in.nexxt/ovalue/vmap/EU/LV': 'Latvia',
    // NORTH AMERICA
    'in.nexxt/ovalue/vmap/W/JM': 'Jamaica',
    'in.nexxt/ovalue/vmap/NA/JM': 'Jamaica',
    'in.nexxt/ovalue/vmap/W/BS': 'Bahamas',
    'in.nexxt/ovalue/vmap/NA/BS': 'Bahamas',
    'in.nexxt/ovalue/vmap/W/BZ': 'Belize',
    'in.nexxt/ovalue/vmap/NA/BZ': 'Belize',
    'in.nexxt/ovalue/vmap/W/GT': 'Guatemala',
    'in.nexxt/ovalue/vmap/NA/GT': 'Guatemala',
    'in.nexxt/ovalue/vmap/W/GL': 'Greenland',
    'in.nexxt/ovalue/vmap/NA/GL': 'Greenland',
    'in.nexxt/ovalue/vmap/W/HN': 'Honduras',
    'in.nexxt/ovalue/vmap/NA/HN': 'Honduras',
    'in.nexxt/ovalue/vmap/W/PR': 'Puerto Rico',
    'in.nexxt/ovalue/vmap/NA/PR': 'Puerto Rico',
    'in.nexxt/ovalue/vmap/W/HT': 'Haiti',
    'in.nexxt/ovalue/vmap/NA/HT': 'Haiti',
    'in.nexxt/ovalue/vmap/W/PA': 'Panama',
    'in.nexxt/ovalue/vmap/NA/PA': 'Panama',
    'in.nexxt/ovalue/vmap/W/MX': 'Mexico',
    'in.nexxt/ovalue/vmap/NA/MX': 'Mexico',
    'in.nexxt/ovalue/vmap/W/NI': 'Nicaragua',
    'in.nexxt/ovalue/vmap/NA/NI': 'Nicaragua',
    'in.nexxt/ovalue/vmap/W/CA': 'Canada',
    'in.nexxt/ovalue/vmap/NA/CA': 'Canada',
    'in.nexxt/ovalue/vmap/W/CR': 'Costa Rica',
    'in.nexxt/ovalue/vmap/NA/CR': 'Costa Rica',
    'in.nexxt/ovalue/vmap/W/CU': 'Cuba',
    'in.nexxt/ovalue/vmap/NA/CU': 'Cuba',
    'in.nexxt/ovalue/vmap/W/SV': 'El Salvador',
    'in.nexxt/ovalue/vmap/NA/SV': 'El Salvador',
    'in.nexxt/ovalue/vmap/W/DO': 'Dominican Rep.',
    'in.nexxt/ovalue/vmap/NA/DO': 'Dominican Rep.',
    'in.nexxt/ovalue/vmap/W/US': 'United States',
    'in.nexxt/ovalue/vmap/NA/US': 'United States',
    'in.nexxt/ovalue/vmap/W/TT': 'Trinidad and Tobago',
    'in.nexxt/ovalue/vmap/NA/TT': 'Trinidad and Tobago',
    // SOUTH AMERICA
    'in.nexxt/ovalue/vmap/W/BR': 'Brazil',
    'in.nexxt/ovalue/vmap/SA/BR': 'Brazil',
    'in.nexxt/ovalue/vmap/W/PY': 'Paraguay',
    'in.nexxt/ovalue/vmap/SA/PY': 'Paraguay',
    'in.nexxt/ovalue/vmap/W/CO': 'Colombia',
    'in.nexxt/ovalue/vmap/SA/CO': 'Colombia',
    'in.nexxt/ovalue/vmap/W/CL': 'Chile',
    'in.nexxt/ovalue/vmap/SA/CL': 'Chile',
    'in.nexxt/ovalue/vmap/W/SR': 'Suriname',
    'in.nexxt/ovalue/vmap/SA/SR': 'Suriname',
    'in.nexxt/ovalue/vmap/W/BO': 'Bolivia',
    'in.nexxt/ovalue/vmap/SA/BO': 'Bolivia',
    'in.nexxt/ovalue/vmap/W/EC': 'Ecuador',
    'in.nexxt/ovalue/vmap/SA/EC': 'Ecuador',
    'in.nexxt/ovalue/vmap/W/AR': 'Argentina',
    'in.nexxt/ovalue/vmap/SA/AR': 'Argentina',
    'in.nexxt/ovalue/vmap/W/GY': 'Guyana',
    'in.nexxt/ovalue/vmap/SA/GY': 'Guyana',
    'in.nexxt/ovalue/vmap/W/PE': 'Peru',
    'in.nexxt/ovalue/vmap/SA/PE': 'Peru',
    'in.nexxt/ovalue/vmap/W/UY': 'Uruguay',
    'in.nexxt/ovalue/vmap/SA/UY': 'Uruguay',
    'in.nexxt/ovalue/vmap/W/FK': 'Falkland Is.',
    'in.nexxt/ovalue/vmap/SA/FK': 'Falkland Is.',
    'in.nexxt/ovalue/vmap/W/VE': 'Venezuela',
    'in.nexxt/ovalue/vmap/SA/VE': 'Venezuela',
    // OCEANIA
    'in.nexxt/ovalue/vmap/W/NC': 'New Caledonia',
    'in.nexxt/ovalue/vmap/OC/NC': 'New Caledonia',
    'in.nexxt/ovalue/vmap/W/NZ': 'New Zealand',
    'in.nexxt/ovalue/vmap/OC/NZ': 'New Zealand',
    'in.nexxt/ovalue/vmap/W/AU': 'Australia',
    'in.nexxt/ovalue/vmap/OC/AU': 'Australia',
    'in.nexxt/ovalue/vmap/W/PG': 'Papua New Guinea',
    'in.nexxt/ovalue/vmap/OC/PG': 'Papua New Guinea',
    'in.nexxt/ovalue/vmap/W/SB': 'Solomon Is.',
    'in.nexxt/ovalue/vmap/OC/SB': 'Solomon Is.',
    'in.nexxt/ovalue/vmap/W/FJ': 'Fiji',
    'in.nexxt/ovalue/vmap/OC/FJ': 'Fiji',
    'in.nexxt/ovalue/vmap/W/VU': 'Vanuatu',
    'in.nexxt/ovalue/vmap/OC/VU': 'Vanuatu',
    // AFRICA
    'in.nexxt/ovalue/vmap/W/BF': 'Burkina Faso',
    'in.nexxt/ovalue/vmap/AF/BF': 'Burkina Faso',
    'in.nexxt/ovalue/vmap/W/BJ': 'Benin',
    'in.nexxt/ovalue/vmap/AF/BJ': 'Benin',
    'in.nexxt/ovalue/vmap/W/BW': 'Botswana',
    'in.nexxt/ovalue/vmap/AF/BW': 'Botswana',
    'in.nexxt/ovalue/vmap/W/BI': 'Burundi',
    'in.nexxt/ovalue/vmap/AF/BI': 'Burundi',
    'in.nexxt/ovalue/vmap/W/ZA': 'South Africa',
    'in.nexxt/ovalue/vmap/AF/ZA': 'South Africa',
    'in.nexxt/ovalue/vmap/W/DZ': 'Algeria',
    'in.nexxt/ovalue/vmap/AF/DZ': 'Algeria',
    'in.nexxt/ovalue/vmap/W/ET': 'Ethiopia',
    'in.nexxt/ovalue/vmap/AF/ET': 'Ethiopia',
    'in.nexxt/ovalue/vmap/W/RW': 'Rwanda',
    'in.nexxt/ovalue/vmap/AF/RW': 'Rwanda',
    'in.nexxt/ovalue/vmap/W/TZ': 'Tanzania',
    'in.nexxt/ovalue/vmap/AF/TZ': 'Tanzania',
    'in.nexxt/ovalue/vmap/W/GQ': 'Eq. Guinea',
    'in.nexxt/ovalue/vmap/AF/GQ': 'Eq. Guinea',
    'in.nexxt/ovalue/vmap/W/NA': 'Namibia',
    'in.nexxt/ovalue/vmap/AF/NA': 'Namibia',
    'in.nexxt/ovalue/vmap/W/NE': 'Niger',
    'in.nexxt/ovalue/vmap/AF/NE': 'Niger',
    'in.nexxt/ovalue/vmap/W/NG': 'Nigeria',
    'in.nexxt/ovalue/vmap/AF/NG': 'Nigeria',
    'in.nexxt/ovalue/vmap/W/TN': 'Tunisia',
    'in.nexxt/ovalue/vmap/AF/TN': 'Tunisia',
    'in.nexxt/ovalue/vmap/W/LR': 'Liberia',
    'in.nexxt/ovalue/vmap/AF/LR': 'Liberia',
    'in.nexxt/ovalue/vmap/W/LS': 'Lesotho',
    'in.nexxt/ovalue/vmap/AF/LS': 'Lesotho',
    'in.nexxt/ovalue/vmap/W/ZW': 'Zimbabwe',
    'in.nexxt/ovalue/vmap/AF/ZW': 'Zimbabwe',
    'in.nexxt/ovalue/vmap/W/TG': 'Togo',
    'in.nexxt/ovalue/vmap/AF/TG': 'Togo',
    'in.nexxt/ovalue/vmap/W/TD': 'Chad',
    'in.nexxt/ovalue/vmap/AF/TD': 'Chad',
    'in.nexxt/ovalue/vmap/W/ER': 'Eritrea',
    'in.nexxt/ovalue/vmap/AF/ER': 'Eritrea',
    'in.nexxt/ovalue/vmap/W/LY': 'Libya',
    'in.nexxt/ovalue/vmap/AF/LY': 'Libya',
    'in.nexxt/ovalue/vmap/W/GW': 'Guinea-Bissau',
    'in.nexxt/ovalue/vmap/AF/GW': 'Guinea-Bissau',
    'in.nexxt/ovalue/vmap/W/ZM': 'Zambia',
    'in.nexxt/ovalue/vmap/AF/ZM': 'Zambia',
    'in.nexxt/ovalue/vmap/W/CI': 'Côte d Ivoire',
    'in.nexxt/ovalue/vmap/AF/CI': 'Côte d Ivoire',
    'in.nexxt/ovalue/vmap/W/EH': 'W. Sahara',
    'in.nexxt/ovalue/vmap/AF/EH': 'W. Sahara',
    'in.nexxt/ovalue/vmap/W/CM': 'Cameroon',
    'in.nexxt/ovalue/vmap/AF/CM': 'Cameroon',
    'in.nexxt/ovalue/vmap/W/EG': 'Egypt',
    'in.nexxt/ovalue/vmap/AF/EG': 'Egypt',
    'in.nexxt/ovalue/vmap/W/SL': 'Sierra Leone',
    'in.nexxt/ovalue/vmap/AF/SL': 'Sierra Leone',
    'in.nexxt/ovalue/vmap/W/CG': 'Congo',
    'in.nexxt/ovalue/vmap/AF/CG': 'Congo',
    'in.nexxt/ovalue/vmap/W/CF': 'Central African Rep.',
    'in.nexxt/ovalue/vmap/AF/CF': 'Central African Rep.',
    'in.nexxt/ovalue/vmap/W/AO': 'Angola',
    'in.nexxt/ovalue/vmap/AF/AO': 'Angola',
    'in.nexxt/ovalue/vmap/W/CD': 'Dem. Rep. Congo',
    'in.nexxt/ovalue/vmap/AF/CD': 'Dem. Rep. Congo',
    'in.nexxt/ovalue/vmap/W/GA': 'Gabon',
    'in.nexxt/ovalue/vmap/AF/GA': 'Gabon',
    'in.nexxt/ovalue/vmap/W/GN': 'Guinea',
    'in.nexxt/ovalue/vmap/AF/GN': 'Guinea',
    'in.nexxt/ovalue/vmap/W/GM': 'Gambia',
    'in.nexxt/ovalue/vmap/AF/GM': 'Gambia',
    'in.nexxt/ovalue/vmap/W/XS': 'Somaliland',
    'in.nexxt/ovalue/vmap/AF/XS': 'Somaliland',
    'in.nexxt/ovalue/vmap/W/GH': 'Ghana',
    'in.nexxt/ovalue/vmap/AF/GH': 'Ghana',
    'in.nexxt/ovalue/vmap/W/SZ': 'Swaziland',
    'in.nexxt/ovalue/vmap/AF/SZ': 'Swaziland',
    'in.nexxt/ovalue/vmap/W/MG': 'Madagascar',
    'in.nexxt/ovalue/vmap/AF/MG': 'Madagascar',
    'in.nexxt/ovalue/vmap/W/MA': 'Morocco',
    'in.nexxt/ovalue/vmap/AF/MA': 'Morocco',
    'in.nexxt/ovalue/vmap/W/KE': 'Kenya',
    'in.nexxt/ovalue/vmap/AF/KE': 'Kenya',
    'in.nexxt/ovalue/vmap/W/SS': 'S. Sudan',
    'in.nexxt/ovalue/vmap/AF/SS': 'S. Sudan',
    'in.nexxt/ovalue/vmap/W/ML': 'Mali',
    'in.nexxt/ovalue/vmap/AF/ML': 'Mali',
    'in.nexxt/ovalue/vmap/W/MW': 'Malawi',
    'in.nexxt/ovalue/vmap/AF/MW': 'Malawi',
    'in.nexxt/ovalue/vmap/W/SO': 'Somalia',
    'in.nexxt/ovalue/vmap/AF/SO': 'Somalia',
    'in.nexxt/ovalue/vmap/W/SN': 'Senegal',
    'in.nexxt/ovalue/vmap/AF/SN': 'Senegal',
    'in.nexxt/ovalue/vmap/W/MR': 'Mauritania',
    'in.nexxt/ovalue/vmap/AF/MR': 'Mauritania',
    'in.nexxt/ovalue/vmap/W/UG': 'Uganda',
    'in.nexxt/ovalue/vmap/AF/UG': 'Uganda',
    'in.nexxt/ovalue/vmap/W/SD': 'Sudan',
    'in.nexxt/ovalue/vmap/AF/SD': 'Sudan',
    'in.nexxt/ovalue/vmap/W/MZ': 'Mozambique',
    'in.nexxt/ovalue/vmap/AF/MZ': 'Mozambique',
    'in.nexxt/ovalue/vmap/W/DJ': 'Djibouti',
    'in.nexxt/ovalue/vmap/AF/DJ': 'Djibouti',
    'in.nexxt/ovalue/vmap/W/TF': 'Fr. S. Antarctic Lands',
    'in.nexxt/ovalue/vmap/AF/TF': 'Fr. S. Antarctic Lands'
};
// Hacky regex solution for filtering through vector map codes
// @TODO: restructure our data and/or typing to handle this better
var FILTER_VECTOR_MAP_CODES = function (region) {
    var reg = new RegExp("^in.nexxt/ovalue/vmap/".concat(region.identifier, "/[A-Z]*-?[A-Z]*$"), 'gm');
    return _.pickBy(exports.VECTOR_MAP_REGION_CODES, function (value, key) { return reg.test(key); });
};
exports.FILTER_VECTOR_MAP_CODES = FILTER_VECTOR_MAP_CODES;
/*
 * This function takes in a vmap ovalue (in.nexxt/ovalue/vmap/../..)
 * and returns the appropriate jvectormap id.
 * @TODO: handle this better
 */
var EXTRACT_VECTOR_MAP_REGION_ID = function (regionQuestionValue) {
    var valueSplit = regionQuestionValue.split('/');
    return _.last(valueSplit) || '';
};
exports.EXTRACT_VECTOR_MAP_REGION_ID = EXTRACT_VECTOR_MAP_REGION_ID;
exports.CUSTOM_OPTION_IDENTIFIER = -1;
exports.CUSTOM_QUESTION_IDENTIFIER = -1;
exports.ICON_OPTION_VALUE = [
    'in.nexxt/ovalue/icon/1',
    'in.nexxt/ovalue/icon/2',
    'in.nexxt/ovalue/icon/3',
    'in.nexxt/ovalue/icon/4',
    'in.nexxt/ovalue/icon/5',
    'in.nexxt/ovalue/icon/6',
    'in.nexxt/ovalue/icon/7'
];
exports.iconURLs = {
    hearts: {
        unselected: "".concat(exports.STATIC_STORAGE_URL, "/img/heart-grey.png"),
        selected: "".concat(exports.STATIC_STORAGE_URL, "/img/heart-red.png")
    },
    thumbs: {
        unselected: "".concat(exports.STATIC_STORAGE_URL, "/img/questionTypes/thumbs_unselected.png"),
        selected: "".concat(exports.STATIC_STORAGE_URL, "/img/questionTypes/thumbs_selected_yellow.png")
    },
    stars: {
        unselected: "".concat(exports.STATIC_STORAGE_URL, "/img/questionTypes/star_unselected.png"),
        selected: "".concat(exports.STATIC_STORAGE_URL, "/img/questionTypes/star_selected.png")
    }
};
exports.projectLanguage = [
    {
        value: 'en',
        label: 'English',
        title: 'English',
        native: 'English',
        optionValue: 'in.nexxt/ovalue/language/en'
    },
    {
        value: 'af',
        label: 'Afrikaans',
        title: 'Afrikaans',
        native: 'Afrikaans',
        optionValue: 'in.nexxt/ovalue/language/af'
    },
    {
        value: 'sq',
        label: 'Albanian',
        title: 'Albanian',
        native: 'Shqip',
        optionValue: 'in.nexxt/ovalue/language/sq'
    },
    {
        value: 'am',
        label: 'Amharic',
        title: 'Amharic',
        native: 'አማርኛ',
        optionValue: 'in.nexxt/ovalue/language/am'
    },
    {
        value: 'ar',
        label: 'Arabic (MSA)',
        title: 'Arabic (MSA)',
        native: 'العربية',
        optionValue: 'in.nexxt/ovalue/language/ar'
    },
    {
        value: 'ar_EG',
        label: 'Arabic (Egyptian)',
        title: 'Arabic (Egyptian)',
        native: 'العربية المصرية',
        optionValue: 'in.nexxt/ovalue/language/ar_EG'
    },
    {
        value: 'ar_LB',
        label: 'Arabic (Levantine)',
        title: 'Arabic (Levantine)',
        native: 'العربية الشامية',
        optionValue: 'in.nexxt/ovalue/language/ar_LB'
    },
    {
        value: 'ar_SA',
        label: 'Arabic (Gulf)',
        title: 'Arabic (Gulf)',
        native: 'العربية الخليجية',
        optionValue: 'in.nexxt/ovalue/language/ar_SA'
    },
    {
        value: 'ar_MA',
        label: 'Arabic (Maghrebi)',
        title: 'Arabic (Maghrebi)',
        native: 'العربية المغاربية',
        optionValue: 'in.nexxt/ovalue/language/ar_MA'
    },
    {
        value: 'hy',
        label: 'Armenian',
        title: 'Armenian',
        native: 'Հայերեն',
        optionValue: 'in.nexxt/ovalue/language/hy'
    },
    {
        value: 'az',
        label: 'Azerbaijani',
        title: 'Azerbaijani',
        native: 'Azərbaycan dili',
        optionValue: 'in.nexxt/ovalue/language/az'
    },
    {
        value: 'eu',
        label: 'Basque',
        title: 'Basque',
        native: 'Euskara',
        optionValue: 'in.nexxt/ovalue/language/eu'
    },
    {
        value: 'bn',
        label: 'Bengali',
        title: 'Bengali',
        native: 'বাংলা',
        optionValue: 'in.nexxt/ovalue/language/bn'
    },
    {
        value: 'bs',
        label: 'Bosnian',
        title: 'Bosnian',
        native: 'Bosanski',
        optionValue: 'in.nexxt/ovalue/language/bs'
    },
    {
        value: 'bg',
        label: 'Bulgarian',
        title: 'Bulgarian',
        native: 'Български',
        optionValue: 'in.nexxt/ovalue/language/bg'
    },
    {
        value: 'my',
        label: 'Burmese (Myanmar)',
        title: 'Burmese (Myanmar)',
        native: 'မြန်မာစာ',
        optionValue: 'in.nexxt/ovalue/language/my'
    },
    {
        value: 'ca',
        label: 'Catalan',
        title: 'Catalan',
        native: 'Català',
        optionValue: 'in.nexxt/ovalue/language/ca'
    },
    {
        value: 'zh_CN',
        label: 'Chinese (Mandarin, Simplified)',
        title: 'Chinese (Mandarin, Simplified)',
        native: '简体中文',
        optionValue: 'in.nexxt/ovalue/language/zh_CN'
    },
    {
        value: 'zh_TW',
        label: 'Chinese (Mandarin, Traditional)',
        title: 'Chinese (Mandarin, Traditional)',
        native: '繁體中文',
        optionValue: 'in.nexxt/ovalue/language/zh_TW'
    },
    {
        value: 'zh_HK',
        label: 'Chinese (Cantonese, Traditional)',
        title: 'Chinese (Cantonese, Traditional)',
        native: '繁體中文 (粵語)',
        optionValue: 'in.nexxt/ovalue/language/zh_HK'
    },
    {
        value: 'hr',
        label: 'Croatian',
        title: 'Croatian',
        native: 'Hrvatski',
        optionValue: 'in.nexxt/ovalue/language/hr'
    },
    {
        value: 'cs',
        label: 'Czech',
        title: 'Czech',
        native: 'Čeština',
        optionValue: 'in.nexxt/ovalue/language/cs'
    },
    {
        value: 'da',
        label: 'Danish',
        title: 'Danish',
        native: 'Dansk',
        optionValue: 'in.nexxt/ovalue/language/da'
    },
    {
        value: 'nl',
        label: 'Dutch',
        title: 'Dutch',
        native: 'Nederlands',
        optionValue: 'in.nexxt/ovalue/language/nl'
    },
    {
        value: 'en_GB',
        label: 'English (UK)',
        title: 'English (UK)',
        native: 'English',
        optionValue: 'in.nexxt/ovalue/language/en_GB'
    },
    {
        value: 'et',
        label: 'Estonian',
        title: 'Estonian',
        native: 'Eesti',
        optionValue: 'in.nexxt/ovalue/language/et'
    },
    {
        value: 'tl',
        label: 'Tagalog (Filipino)',
        title: 'Tagalog (Filipino)',
        native: 'Tagalog',
        optionValue: 'in.nexxt/ovalue/language/tl'
    },
    {
        value: 'fi',
        label: 'Finnish',
        title: 'Finnish',
        native: 'Suomi',
        optionValue: 'in.nexxt/ovalue/language/fi'
    },
    {
        value: 'fr',
        label: 'French (France)',
        title: 'French (France)',
        native: 'Français',
        optionValue: 'in.nexxt/ovalue/language/fr'
    },
    {
        value: 'fr_CA',
        label: 'French (Canada)',
        title: 'French (Canada)',
        native: 'Français (Canada)',
        optionValue: 'in.nexxt/ovalue/language/fr_CA'
    },
    {
        value: 'gl',
        label: 'Galician',
        title: 'Galician',
        native: 'Galego',
        optionValue: 'in.nexxt/ovalue/language/gl'
    },
    {
        value: 'ka',
        label: 'Georgian',
        title: 'Georgian',
        native: 'ქართული',
        optionValue: 'in.nexxt/ovalue/language/ka'
    },
    {
        value: 'de',
        label: 'German (Germany)',
        title: 'German (Germany)',
        native: 'Deutsch',
        optionValue: 'in.nexxt/ovalue/language/de'
    },
    {
        value: 'de_CH',
        label: 'German (Switzerland)',
        title: 'German (Switzerland)',
        native: 'Deutsch (Schweiz)',
        optionValue: 'in.nexxt/ovalue/language/de_CH'
    },
    {
        value: 'de_AT',
        label: 'German (Austria)',
        title: 'German (Austria)',
        native: 'Deutsch (Österreich)',
        optionValue: 'in.nexxt/ovalue/language/de_AT'
    },
    {
        value: 'el',
        label: 'Greek',
        title: 'Greek',
        native: 'Ελληνικά',
        optionValue: 'in.nexxt/ovalue/language/el'
    },
    {
        value: 'gu',
        label: 'Gujarati',
        title: 'Gujarati',
        native: 'ગુજરાતી',
        optionValue: 'in.nexxt/ovalue/language/gu'
    },
    {
        value: 'iw',
        label: 'Hebrew',
        title: 'Hebrew',
        native: 'עברית',
        optionValue: 'in.nexxt/ovalue/language/iw'
    },
    {
        value: 'hi',
        label: 'Hindi',
        title: 'Hindi',
        native: 'हिन्दी',
        optionValue: 'in.nexxt/ovalue/language/hi'
    },
    // {
    //     value: 'hi_Latin',
    //     label: 'Hindi (Latin)',
    //     title: 'Hindi (Latin)',
    //     native: 'Hinglish',
    //     optionValue: 'in.nexxt/ovalue/language/hi_Latin'
    // },
    {
        value: 'hu',
        label: 'Hungarian',
        title: 'Hungarian',
        native: 'Magyar',
        optionValue: 'in.nexxt/ovalue/language/hu'
    },
    {
        value: 'is',
        label: 'Icelandic',
        title: 'Icelandic',
        native: 'Íslenska',
        optionValue: 'in.nexxt/ovalue/language/is'
    },
    {
        value: 'id',
        label: 'Indonesian',
        title: 'Indonesian',
        native: 'Bahasa Indonesia',
        optionValue: 'in.nexxt/ovalue/language/id'
    },
    {
        value: 'it',
        label: 'Italian',
        title: 'Italian',
        native: 'Italiano',
        optionValue: 'in.nexxt/ovalue/language/it'
    },
    {
        value: 'ja',
        label: 'Japanese',
        title: 'Japanese',
        native: '日本語',
        optionValue: 'in.nexxt/ovalue/language/ja'
    },
    {
        value: 'jv',
        label: 'Javanese',
        title: 'Javanese',
        native: 'Basa Jawa',
        optionValue: 'in.nexxt/ovalue/language/jv'
    },
    {
        value: 'kn',
        label: 'Kannada',
        title: 'Kannada',
        native: 'ಕನ್ನಡ',
        optionValue: 'in.nexxt/ovalue/language/kn'
    },
    {
        value: 'kk',
        label: 'Kazahkh',
        title: 'Kazahkh',
        native: 'Қазақ тілі',
        optionValue: 'in.nexxt/ovalue/language/kk'
    },
    {
        value: 'km',
        label: 'Khmer',
        title: 'Khmer',
        native: 'ខ្មែរ',
        optionValue: 'in.nexxt/ovalue/language/km'
    },
    {
        value: 'rw',
        label: 'Kinyarwanda (Rwanda)',
        title: 'Kinyarwanda (Rwanda)',
        native: 'Ikinyarwanda',
        optionValue: 'in.nexxt/ovalue/language/rw'
    },
    {
        value: 'ko',
        label: 'Korean',
        title: 'Korean',
        native: '한국어',
        optionValue: 'in.nexxt/ovalue/language/ko'
    },
    {
        value: 'lo',
        label: 'Lao',
        title: 'Lao',
        native: 'ລາວ',
        optionValue: 'in.nexxt/ovalue/language/lo'
    },
    {
        value: 'lv',
        label: 'Latvian',
        title: 'Latvian',
        native: 'Latviešu',
        optionValue: 'in.nexxt/ovalue/language/lv'
    },
    {
        value: 'lt',
        label: 'Lithuanian',
        title: 'Lithuanian',
        native: 'Lietuvių',
        optionValue: 'in.nexxt/ovalue/language/lt'
    },
    {
        value: 'mk',
        label: 'Macedonian',
        title: 'Macedonian',
        native: 'Македонски',
        optionValue: 'in.nexxt/ovalue/language/mk'
    },
    {
        value: 'ms',
        label: 'Malay',
        title: 'Malay',
        native: 'Bahasa Melayu',
        optionValue: 'in.nexxt/ovalue/language/ms'
    },
    {
        value: 'ml',
        label: 'Malayalam',
        title: 'Malayalam',
        native: 'മലയാളം',
        optionValue: 'in.nexxt/ovalue/language/ml'
    },
    {
        value: 'mr',
        label: 'Marathi',
        title: 'Marathi',
        native: 'मराठी',
        optionValue: 'in.nexxt/ovalue/language/mr'
    },
    {
        value: 'mn',
        label: 'Mongolian',
        title: 'Mongolian',
        native: 'Монгол',
        optionValue: 'in.nexxt/ovalue/language/mn'
    },
    {
        value: 'ne',
        label: 'Nepali',
        title: 'Nepali',
        native: 'नेपाली',
        optionValue: 'in.nexxt/ovalue/language/ne'
    },
    {
        value: 'no',
        label: 'Norwegian',
        title: 'Norwegian',
        native: 'Norsk',
        optionValue: 'in.nexxt/ovalue/language/no'
    },
    {
        value: 'fa',
        label: 'Persian',
        title: 'Persian',
        native: 'فارسی',
        optionValue: 'in.nexxt/ovalue/language/fa'
    },
    {
        value: 'pl',
        label: 'Polish',
        title: 'Polish',
        native: 'Polski',
        optionValue: 'in.nexxt/ovalue/language/pl'
    },
    {
        value: 'pt',
        label: 'Portuguese (Portugal)',
        title: 'Portuguese (Portugal)',
        native: 'Português',
        optionValue: 'in.nexxt/ovalue/language/pt'
    },
    {
        value: 'pt_BR',
        label: 'Portuguese (Brazilian)',
        title: 'Portuguese (Brazilian)',
        native: 'Português (Brasil)',
        optionValue: 'in.nexxt/ovalue/language/pt_BR'
    },
    {
        value: 'pa',
        label: 'Punjabi',
        title: 'Punjabi',
        native: 'ਪੰਜਾਬੀ',
        optionValue: 'in.nexxt/ovalue/language/pa'
    },
    {
        value: 'ro',
        label: 'Romanian',
        title: 'Romanian',
        native: 'Română',
        optionValue: 'in.nexxt/ovalue/language/ro'
    },
    {
        value: 'ru',
        label: 'Russian',
        title: 'Russian',
        native: 'Русский',
        optionValue: 'in.nexxt/ovalue/language/ru'
    },
    {
        value: 'sr',
        label: 'Serbian',
        title: 'Serbian',
        native: 'Српски',
        optionValue: 'in.nexxt/ovalue/language/sr'
    },
    {
        value: 'si',
        label: 'Sinhala',
        title: 'Sinhala',
        native: 'සිංහල',
        optionValue: 'in.nexxt/ovalue/language/si'
    },
    {
        value: 'sk',
        label: 'Slovak',
        title: 'Slovak',
        native: 'Slovenčina',
        optionValue: 'in.nexxt/ovalue/language/sk'
    },
    {
        value: 'sl',
        label: 'Slovenian',
        title: 'Slovenian',
        native: 'Slovenščina',
        optionValue: 'in.nexxt/ovalue/language/sl'
    },
    {
        value: 'st',
        label: 'Southern Sotho (Sesotho)',
        title: 'Southern Sotho (Sesotho)',
        native: 'Sesotho',
        optionValue: 'in.nexxt/ovalue/language/st'
    },
    {
        value: 'su',
        label: 'Sundanese',
        title: 'Sundanese',
        native: 'Basa Sunda',
        optionValue: 'in.nexxt/ovalue/language/su'
    },
    {
        value: 'sw',
        label: 'Swahili',
        title: 'Swahili',
        native: 'Kiswahili',
        optionValue: 'in.nexxt/ovalue/language/sw'
    },
    {
        value: 'es',
        label: 'Spanish (Spain)',
        title: 'Spanish (Spain)',
        native: 'Español',
        optionValue: 'in.nexxt/ovalue/language/es'
    },
    {
        value: 'es_MX',
        label: 'Spanish (Mexico)',
        title: 'Spanish (Mexico)',
        native: 'Español (México)',
        optionValue: 'in.nexxt/ovalue/language/es_MX'
    },
    {
        value: 'es_AR',
        label: 'Spanish (Argentina)',
        title: 'Spanish (Argentina)',
        native: 'Español (Argentina)',
        optionValue: 'in.nexxt/ovalue/language/es_AR'
    },
    {
        value: 'sv',
        label: 'Swedish',
        title: 'Swedish',
        native: 'Svenska',
        optionValue: 'in.nexxt/ovalue/language/sv'
    },
    {
        value: 'ta',
        label: 'Tamil',
        title: 'Tamil',
        native: 'தமிழ்',
        optionValue: 'in.nexxt/ovalue/language/ta'
    },
    {
        value: 'te',
        label: 'Telugu',
        title: 'Telugu',
        native: 'తెలుగు',
        optionValue: 'in.nexxt/ovalue/language/te'
    },
    {
        value: 'th',
        label: 'Thai',
        title: 'Thai',
        native: 'ไทย',
        optionValue: 'in.nexxt/ovalue/language/th'
    },
    {
        value: 'ts',
        label: 'Tsonga',
        title: 'Tsonga',
        native: 'Xitsonga',
        optionValue: 'in.nexxt/ovalue/language/ts'
    },
    {
        value: 'tr',
        label: 'Turkish',
        title: 'Turkish',
        native: 'Türkçe',
        optionValue: 'in.nexxt/ovalue/language/tr'
    },
    {
        value: 'uk',
        label: 'Ukrainian',
        title: 'Ukrainian',
        native: 'Українська',
        optionValue: 'in.nexxt/ovalue/language/uk'
    },
    {
        value: 'ur',
        label: 'Urdu',
        title: 'Urdu',
        native: 'اردو',
        optionValue: 'in.nexxt/ovalue/language/ur'
    },
    {
        value: 'uz',
        label: 'Uzbek',
        title: 'Uzbek',
        native: 'Oʻzbek',
        optionValue: 'in.nexxt/ovalue/language/uz'
    },
    {
        value: 've',
        label: 'Venda',
        title: 'Venda',
        native: 'Tshivenḓa',
        optionValue: 'in.nexxt/ovalue/language/ve'
    },
    {
        value: 'vi',
        label: 'Vietnamese',
        title: 'Vietnamese',
        native: 'Tiếng Việt',
        optionValue: 'in.nexxt/ovalue/language/vi'
    },
    {
        value: 'xh',
        label: 'Xhosa',
        title: 'Xhosa',
        native: 'isiXhosa',
        optionValue: 'in.nexxt/ovalue/language/xh'
    },
    {
        value: 'zu',
        label: 'Zulu',
        title: 'Zulu',
        native: 'isiZulu',
        optionValue: 'in.nexxt/ovalue/language/zu'
    }
];
/**
 * Codes for languages that don't use casing (i.e. capitalization).
 * Casing functions are therefore not applicable for these languages.
 */
exports.NON_CASING_LANGUAGE_VALUES = ['ja', 'ko', 'zh_CN', 'zh_TW'];
exports.DEFAULT_LANGUAGE = exports.projectLanguage.find(function (l) { return l.value === exports.ENGLISH; });
exports.languageMapping = exports.projectLanguage.reduce(function (o, key) {
    var _a;
    return Object.assign(o, (_a = {}, _a[key.value] = key.label, _a));
}, {});
// this var could probably be removed, and we just use projectLanguage,
// however it is kept here for now for legacy reasons (would need to fix a couple places in codebase)
exports.LANGUAGES = exports.projectLanguage.map(function (l) {
    return { value: l.optionValue, label: l.label };
});
exports.INCA_LOGO_WHITE = exports.STATIC_STORAGE_URL + '/img/inca_white.png';
// Dashboard
exports.COLOR_THEME = {
    blue: '#2D67CB',
    red: '#F68685',
    green: '#349A71',
    yellow: '#FFD05A',
    pink: '#C54E76',
    orange: '#F47559',
    lightGreen: '#8DCFC5',
    darkGreen: '#368176',
    purple: '#A889FA',
    darkOrange: '#F54E4C',
    chartColor1: '#EE7900',
    chartColor2: '#369F85',
    chartColor3: '#E4BAC9',
    chartColor4: '#41ABB3',
    chartColor5: '#FBD8CB',
    chartColor6: '#255025',
    chartColor7: '#253A84',
    chartColor8: '#AD9F9A',
    chartColor9: '#BF759C',
    white: '#FFFFFF',
    black: '#000000',
    gray: '#4f4f4f',
    lightGray: '#828282'
};
exports.KEY_NAME = {
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    SPACE: ' ',
    TAB: 'Tab',
    SHIFT: 'Shift'
};
exports.DYNAMIC_TEXT_REFERENCE_TAG = '<R>';
var twoDaysInSeconds = 172800;
var twoWeeksInSeconds = 1209600;
var oneMonthInSeconds = 2592000;
exports.DATA_API_CACHE_TTL = oneMonthInSeconds;
exports.REQUEST_DATA_TTL = twoDaysInSeconds;
var DEFAULT_GREETING = function () { return ({
    label: 'Greeting',
    texts: [
        {
            id: uuid.v4(),
            type: types_1.MULTIMEDIA_TYPES.RICH_TEXT,
            richText: (0, TextService_1.createNewRichTextObject)('Hi, I’m inca, an AI chatbot for research and feedback. Nice to meet you! 😊')
        },
        {
            id: uuid.v4(),
            type: types_1.MULTIMEDIA_TYPES.RICH_TEXT,
            richText: (0, TextService_1.createNewRichTextObject)('Today I’d like to chat with you about…')
        }
    ],
    type: 'default'
}); };
exports.DEFAULT_GREETING = DEFAULT_GREETING;
var DEFAULT_REDIRECT = function () { return ({
    label: 'Departing message',
    redirects: [
        {
            type: 1,
            multimediaTexts: [
                {
                    language: 'en',
                    contents: [
                        {
                            id: uuid.v4(),
                            type: types_1.MULTIMEDIA_TYPES.RICH_TEXT,
                            richText: (0, TextService_1.createNewRichTextObject)("🎉 🎉 That's all! I really appreciate you giving me a few minutes of your time to help me out.")
                        },
                        {
                            id: uuid.v4(),
                            type: types_1.MULTIMEDIA_TYPES.RICH_TEXT,
                            richText: (0, TextService_1.createNewRichTextObject)('Chat again soon. Cheers! 👋')
                        }
                    ]
                }
            ]
        },
        {
            type: 2,
            multimediaTexts: [
                {
                    language: 'en',
                    contents: [
                        {
                            id: uuid.v4(),
                            type: types_1.MULTIMEDIA_TYPES.RICH_TEXT,
                            richText: (0, TextService_1.createNewRichTextObject)('Thanks! It doesn’t look like I have anything relevant for you today. I appreciate you taking the time to chat with me. Hope to see you again soon. Take care! 😃🤗')
                        }
                    ]
                }
            ]
        },
        {
            type: 3,
            multimediaTexts: [
                {
                    language: 'en',
                    contents: [
                        {
                            id: uuid.v4(),
                            type: types_1.MULTIMEDIA_TYPES.RICH_TEXT,
                            richText: (0, TextService_1.createNewRichTextObject)('Thanks! It doesn’t look like I have anything relevant for you today. I appreciate you taking the time to chat with me. Hope to see you again soon. Take care! 😃🤗')
                        }
                    ]
                }
            ]
        },
        {
            type: 4,
            multimediaTexts: [
                {
                    language: 'en',
                    contents: [
                        {
                            id: uuid.v4(),
                            type: types_1.MULTIMEDIA_TYPES.RICH_TEXT,
                            richText: (0, TextService_1.createNewRichTextObject)('Thanks! It doesn’t look like I have anything relevant for you today. I appreciate you taking the time to chat with me. Hope to see you again soon. Take care! 😃🤗')
                        }
                    ]
                }
            ]
        }
    ]
}); };
exports.DEFAULT_REDIRECT = DEFAULT_REDIRECT;
exports.URL_VALIDATE_REGEX = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w\-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
exports.FILENAME_VALIDATE_REGEX = /(.+?)(\.[^.]*$|$)/;
exports.PROFILE_PICTURE = 'profilePicture';
exports.USER_DETAILS = 'userDetails';
exports.TENANT_ID = 'tenantId';
exports.TENANT_NAME = 'tenantName';
exports.TENANT_URL = 'tenantUrl';
exports.TENANT_LEVEL_KEY = 'tenantLevel';
exports.AVAILABLE_PROJECTS = 'availableProjects';
exports.HAS_VOICE_PLUS_ACCESS = 'hasAgreedToVoicePlusTerms';
exports.HAS_AVATAR_ACCESS = 'hasAgreedToAvatarTerms';
exports.ACCOUNT_MANAGER = 'ACCOUNT_MANAGER';
exports.PROJECT_MANAGER = 'PROJECT_MANAGER';
exports.ACCESS_TYPE = 'accessType';
exports.CLIENT_ID = 'clientID';
exports.STATUS = 'status';
exports.ALL = 'ALL';
exports.GREETING_IMAGE = 'greetingImage';
exports.GREETING_TEXT = 'Greeting text';
var PACKAGED_SOLUTION_QIDS;
(function (PACKAGED_SOLUTION_QIDS) {
    PACKAGED_SOLUTION_QIDS[PACKAGED_SOLUTION_QIDS["BULID_FROM_SCRATCH"] = -1] = "BULID_FROM_SCRATCH";
    PACKAGED_SOLUTION_QIDS[PACKAGED_SOLUTION_QIDS["VIDEO_AD"] = 966] = "VIDEO_AD";
    PACKAGED_SOLUTION_QIDS[PACKAGED_SOLUTION_QIDS["IDEA_SCREENING"] = 1052] = "IDEA_SCREENING";
    PACKAGED_SOLUTION_QIDS[PACKAGED_SOLUTION_QIDS["IMAGE_AD"] = 1053] = "IMAGE_AD";
    PACKAGED_SOLUTION_QIDS[PACKAGED_SOLUTION_QIDS["COPY_TEST"] = 2193] = "COPY_TEST";
    PACKAGED_SOLUTION_QIDS[PACKAGED_SOLUTION_QIDS["RAPID_VIDEO_AD"] = 1581] = "RAPID_VIDEO_AD";
    PACKAGED_SOLUTION_QIDS[PACKAGED_SOLUTION_QIDS["RAPID_COPY_TEST"] = 1724] = "RAPID_COPY_TEST";
    PACKAGED_SOLUTION_QIDS[PACKAGED_SOLUTION_QIDS["RAPID_IMAGE_TEST"] = 1772] = "RAPID_IMAGE_TEST";
    PACKAGED_SOLUTION_QIDS[PACKAGED_SOLUTION_QIDS["RBC_VIDEO_AD"] = 1930] = "RBC_VIDEO_AD";
    PACKAGED_SOLUTION_QIDS[PACKAGED_SOLUTION_QIDS["RBC_COPY_TEST"] = 1931] = "RBC_COPY_TEST";
    PACKAGED_SOLUTION_QIDS[PACKAGED_SOLUTION_QIDS["BRAND_TEST"] = 2319] = "BRAND_TEST";
    PACKAGED_SOLUTION_QIDS[PACKAGED_SOLUTION_QIDS["CX_TEST"] = 2317] = "CX_TEST";
})(PACKAGED_SOLUTION_QIDS = exports.PACKAGED_SOLUTION_QIDS || (exports.PACKAGED_SOLUTION_QIDS = {}));
// QUESTION-SPECIFIC CONSTANTS
// (@TODO: move to a separate file?)
exports.TEXT_HIGHLIGHTER_OPTS = {
    WORD_NUM_BREAKPOINTS: [40, 100],
    FONT_SIZES: [16, 20, 24],
    WORD_DELIMITER: ' '
};
exports.SECOND_IN_MILLISECOND = 1000;
exports.ANNOTATION_BUTTONS = [
    {
        label: 'Like',
        texts: [
            {
                language: 'en',
                contents: [{ type: types_1.MULTIMEDIA_TYPES.TEXT, text: 'Like' }]
            }
        ],
        value: '1',
        mediaURL: "".concat(exports.STATIC_STORAGE_URL, "/img/emojis/simple/like.png")
    },
    {
        label: 'Confused',
        texts: [
            {
                language: 'en',
                contents: [{ type: types_1.MULTIMEDIA_TYPES.TEXT, text: 'Confused' }]
            }
        ],
        value: '2',
        mediaURL: "".concat(exports.STATIC_STORAGE_URL, "/img/emojis/simple/confused.png")
    },
    {
        label: 'Dislike',
        texts: [
            {
                language: 'en',
                contents: [{ type: types_1.MULTIMEDIA_TYPES.TEXT, text: 'Dislike' }]
            }
        ],
        value: '3',
        mediaURL: "".concat(exports.STATIC_STORAGE_URL, "/img/emojis/simple/dislike.png")
    }
];
/**
 * @TODO: somehow consolidate this with ANNOTATION_BUTTONS / improve overall button handling.
 */
exports.TRADEOFF_BUTTONS = [
    {
        label: 'Like',
        texts: [
            {
                language: 'en',
                contents: [{ type: types_1.MULTIMEDIA_TYPES.TEXT, text: 'Like' }]
            }
        ],
        value: '1',
        mediaURL: "".concat(exports.STATIC_STORAGE_URL, "/img/emojis/simple/like.png"),
        type: types_1.ACTION_TYPES.LIKE
    },
    {
        label: 'Not Sure',
        texts: [
            {
                language: 'en',
                contents: [{ type: types_1.MULTIMEDIA_TYPES.TEXT, text: 'Not Sure' }]
            }
        ],
        value: '2',
        mediaURL: "".concat(exports.STATIC_STORAGE_URL, "/img/emojis/simple/confused.png"),
        type: types_1.ACTION_TYPES.NOT_SURE
    },
    {
        label: 'Dislike',
        texts: [
            {
                language: 'en',
                contents: [{ type: types_1.MULTIMEDIA_TYPES.TEXT, text: 'Dislike' }]
            }
        ],
        value: '3',
        mediaURL: "".concat(exports.STATIC_STORAGE_URL, "/img/emojis/simple/dislike.png"),
        type: types_1.ACTION_TYPES.DISLIKE
    }
];
var ANNOTATION_BUTTONS_WITH_TEXT = function (t, langId) {
    return exports.ANNOTATION_BUTTONS.map(function (button) { return (__assign(__assign({}, button), { texts: [
            {
                language: langId,
                contents: [
                    {
                        type: types_1.MULTIMEDIA_TYPES.TEXT,
                        text: t("BUTTON.".concat(button.label.toUpperCase()))
                    }
                ]
            }
        ] })); });
};
exports.ANNOTATION_BUTTONS_WITH_TEXT = ANNOTATION_BUTTONS_WITH_TEXT;
exports.NPS_BUTTONS = [
    {
        label: 'Promoter',
        value: '1'
    },
    {
        label: 'Passive',
        value: '2'
    },
    {
        label: 'Detractor',
        value: '3'
    }
];
exports.DEFAULT_VIDEOJS_OPTIONS = {
    fluid: false,
    fill: true,
    responsive: true,
    preload: 'auto',
    autoplay: true,
    controls: true,
    controlBar: {
        playToggle: true,
        captionsButton: false,
        chaptersButton: false,
        subtitlesButton: false,
        fullscreenToggle: false,
        playbackRateMenuButton: false,
        pictureInPictureToggle: false
    },
    userActions: {
        doubleClick: false
    },
    playsInline: true,
    bigPlayButton: false
};
exports.DEFAULT_DISCOURSE_POLICY = {
    persona: types_1.DISCOURSE_PERSONAS.DEFAULT
};
/**
 * Label of special outlier theme which is treated as a special opt.
 */
exports.SPECIAL_LABEL_OUTLIER = 'OUTLIER:UNCATEGORIZED';
/**
 * Key for uncategorized netcode (parent).
 */
exports.SPECIAL_KEY_UNCATEGORIZED = 'Uncategorized';
/**
 * Mapping of special theme system labels that are mapped to human-readable labels.
 */
exports.SPECIAL_LABELS_MAPPING = (_d = {
        'DATC:GENERIC_POSITIVE': 'Generic Positive',
        'DATC:DONT_KNOW': "Don't Know",
        'DATC:NOTHING': 'Nothing',
        'DATC:GENERIC_NEUTRAL': 'Generic Neutral',
        'DATC:GENERIC_NEGATIVE': 'Generic Negative'
    },
    _d[exports.SPECIAL_LABEL_OUTLIER] = 'Uncategorized',
    _d);
exports.NETCODE_UNCATEGORIZED = 'Uncategorized';
exports.NPS_CATEGORY_VALUES = (_e = {},
    _e[types_1.NPS_CATEGORY.DETRACTOR] = -1,
    _e[types_1.NPS_CATEGORY.PASSIVE] = 0,
    _e[types_1.NPS_CATEGORY.PROMOTER] = 1,
    _e);
exports.NPS_SCORE_TITLE = 'NPS Score';
exports.NPS_CATEGORY_TITLE = 'NPS Category';
exports.TRADE_OFF_OPTIONS = {
    LIKES: 'LIKES',
    DISLIKES: 'DISLIKES',
    FAVORITE: 'FAVORITE',
    OVERALL_SCORE: 'OVERALL_SCORE'
};
exports.RANK_ORDER_OPTIONS = {
    RANK_1: 'RANK_1',
    RANK_2: 'RANK_2',
    RANK_3: 'RANK_3',
    TOTAL_SELECTION: 'TOTAL_SELECTION'
};
exports.NETCODE_SENTIMENT = {
    POSITIVE: 'POS',
    NEUTRAL: 'NEU',
    NEGATIVE: 'NEG'
};
// Survey topics from Dynata API. DO NOT ADD any items aside from topics that Dynata allows. it will break the integration
exports.RESEARCH_DOMAIN_OPTIONS = [
    {
        value: 'AUTOMOTIVE',
        label: 'Automotive'
    },
    {
        value: 'BEVERAGES_ALCOHOLIC',
        label: 'Beverages - Alcoholic'
    },
    {
        value: 'BEVERAGES_NON_ALCOHOLIC',
        label: 'Beverages - Non Alcoholic'
    },
    {
        value: 'BUSINESS',
        label: 'Business'
    },
    {
        value: 'CHILDREN_PARENTING',
        label: 'Children & Parenting'
    },
    {
        value: 'LOYALTY_PROGRAMS',
        label: 'Coalition/Loyalty Programs'
    },
    {
        value: 'DESTINATIONS_TOURISM',
        label: 'Destinations & Tourism'
    },
    {
        value: 'EDUCATION',
        label: 'Education'
    },
    {
        value: 'ELECTRICS_COMPUTERS',
        label: 'Electronics/Computer/Software'
    },
    {
        value: 'ENTERTAINMENT_LEISURE',
        label: 'Entertainment & Leisure'
    },
    {
        value: 'FASHION_CLOTHING',
        label: 'Fashion & Clothing - Other'
    },
    {
        value: 'FINANCE',
        label: 'Finance, Banking, Investing & Insurance'
    },
    {
        value: 'FOOD',
        label: 'Food'
    },
    {
        value: 'GAMBLING_LOTTERY',
        label: 'Gambling/Lottery'
    },
    {
        value: 'GOVERNMENT_POLITICS',
        label: 'Government & Politics'
    },
    {
        value: 'HEALTHCARE',
        label: 'Healthcare'
    },
    {
        value: 'HOME',
        label: 'Home'
    },
    {
        value: 'MEDIA_PUBLISHING',
        label: 'Media & Publishing'
    },
    {
        value: 'PERSONAL_CARE',
        label: 'Personal Care (Toiletries, Beauty, Cosmetics)'
    },
    {
        value: 'RESTAURANTS',
        label: 'Restaurants'
    },
    {
        value: 'SENSITIVE_CONTENT',
        label: 'Sensitive/Explicit Content'
    },
    {
        value: 'SMOKING',
        label: 'Smoking/Tobacco'
    },
    {
        value: 'SOCIAL_RESEARCH',
        label: 'Social Research'
    },
    {
        value: 'SPORTS_FITNESS',
        label: 'Sports, Recreation, Fitness'
    },
    {
        value: 'TELECOMMUNICATIONS',
        label: 'Telecommunications'
    },
    {
        value: 'TRANSPORTATION',
        label: 'Transportation'
    },
    {
        value: 'TRAVEL_AIRLINES',
        label: 'Travel - Airlines'
    },
    {
        value: 'TRAVEL_HOTELS',
        label: 'Travel - Hotels'
    },
    {
        value: 'TRAVEL_SERVICES',
        label: 'Travel Services/Agency/Booking'
    },
    {
        value: 'CREDIT_CARDS',
        label: 'Credit Cards'
    },
    {
        value: 'FASHION_CLOTHING_DEPARTMENT_STORE',
        label: 'Fashion & Clothing - Department Store'
    }
];
exports.MAX_DEMERIT_POINTS_OPTIONS = [
    {
        label: 'Strong - 10 Demerit Points',
        value: 10 /* STRONG */
    },
    {
        label: 'Normal - 5 Demerit Points',
        value: 5 /* NORMAL */
    },
    {
        label: 'Weak - 2 Demerit Points',
        value: 2 /* WEAK */
    },
    {
        label: 'Disabled / No Influence',
        value: 0 /* NONE */
    }
];
var SVC_EVENT_TYPE;
(function (SVC_EVENT_TYPE) {
    SVC_EVENT_TYPE["TRANSACTION"] = "transaction";
    SVC_EVENT_TYPE["ALERT"] = "alert";
    SVC_EVENT_TYPE["JOB"] = "job";
})(SVC_EVENT_TYPE = exports.SVC_EVENT_TYPE || (exports.SVC_EVENT_TYPE = {}));
var SVC_NAMESPACE_TYPE;
(function (SVC_NAMESPACE_TYPE) {
    SVC_NAMESPACE_TYPE["DASHBOARD"] = "dashboard";
    SVC_NAMESPACE_TYPE["PORTAL"] = "portal";
    SVC_NAMESPACE_TYPE["BOT_CLIENT"] = "bot-client";
    SVC_NAMESPACE_TYPE["REFRESH"] = "refresh";
    SVC_NAMESPACE_TYPE["AI_CODING"] = "ai-coding";
    SVC_NAMESPACE_TYPE["CROSSTAB"] = "crosstab";
})(SVC_NAMESPACE_TYPE = exports.SVC_NAMESPACE_TYPE || (exports.SVC_NAMESPACE_TYPE = {}));
var SVC_EVENT_NAME;
(function (SVC_EVENT_NAME) {
    SVC_EVENT_NAME["PUBLISH_PROJECT"] = "publishProject";
    SVC_EVENT_NAME["PAUSE_PROJECT"] = "pauseProject";
    SVC_EVENT_NAME["RESUME_PROJECT"] = "resumeProject";
    SVC_EVENT_NAME["REVIEW_PROJECT"] = "reviewProject";
    SVC_EVENT_NAME["CLOSE_PROJECT"] = "closeProject";
    SVC_EVENT_NAME["PACKAGE_DATA_PICKUP"] = "packageDataPickUp";
    SVC_EVENT_NAME["NEW_RESPONDENT_TERMINATE"] = "newRespondentTerminate";
    SVC_EVENT_NAME["INIT_CHATBOT_SOCKET"] = "initChatbotSocket";
    SVC_EVENT_NAME["ADJUST_QUOTA_CHANGE"] = "adjustQuotaChange";
    SVC_EVENT_NAME["REFRESH_JOB"] = "refreshJob";
    SVC_EVENT_NAME["PACKAGE_REFRESH"] = "packageRefresh";
    SVC_EVENT_NAME["PACKAGE_FINALIZE"] = "packageFinalize";
    SVC_EVENT_NAME["DATA_EXPORT"] = "dataExport";
    SVC_EVENT_NAME["MANUAL_AI_CODING"] = "manualAICoding";
    SVC_EVENT_NAME["GLOBAL_REFRESH"] = "globalRefresh";
    SVC_EVENT_NAME["CREATE_AI_CODING_PORTAL"] = "createAiCodingPortal";
    SVC_EVENT_NAME["CREATE_AI_CODING_DASHBOARD"] = "createAiCodingDashboard";
})(SVC_EVENT_NAME = exports.SVC_EVENT_NAME || (exports.SVC_EVENT_NAME = {}));
exports.TRADE_OFF_TEXT_BASED_OPTION_CARD = 'TEXT_CARD_NO_URL';
/** HEYGEN / DIGITAL AVATAR CONSTANTS */
exports.HEYGEN_AVATARS = [
    {
        name: 'Angela in Black Dress',
        streamingAvatarId: 'Angela-inblackskirt-20220820',
        language: 'en'
    },
    {
        name: 'Anna in Brown T-Shirt',
        streamingAvatarId: 'Anna_public_3_20240108',
        language: 'en'
    },
    {
        name: 'Briana in Brown Suit',
        streamingAvatarId: 'Briana_public_3_20240110',
        language: 'en'
    },
    {
        name: 'Joshua HeyGen CEO',
        streamingAvatarId: 'josh_lite3_20230714',
        language: 'en',
        default: true
    },
    {
        name: 'Justin in White Shirt',
        streamingAvatarId: 'Justin_public_3_20240308',
        language: 'en'
    },
    {
        name: 'Kayla in Casual Suit',
        streamingAvatarId: 'Kayla-incasualsuit-20220818',
        language: 'en'
    },
    {
        name: 'Kristin in Black Suit',
        streamingAvatarId: 'Kristin_public_2_20240108',
        language: 'en'
    },
    {
        name: 'Leah in Black Suit',
        streamingAvatarId: 'Lily_public_pro1_20230614',
        language: 'en'
    },
    {
        name: 'Tyler in Casual Suit',
        streamingAvatarId: 'Tyler-incasualsuit-20220721',
        language: 'en'
    },
    {
        name: 'Tyler in Shirt',
        streamingAvatarId: 'Tyler-inshirt-20220721',
        language: 'en'
    },
    {
        name: 'Tyler in Suit',
        streamingAvatarId: 'Tyler-insuit-20220721',
        language: 'en'
    },
    {
        name: 'Wade in Black Jacket',
        streamingAvatarId: 'Wade_public_2_20240228',
        language: 'en'
    }
];
exports.DEEPGRAM_AVATARS = [
    {
        label: 'Asteria',
        value: 'aura-asteria-en',
        language: 'en',
        default: true
    },
    {
        label: 'Luna',
        value: 'aura-luna-en',
        language: 'en'
    },
    {
        label: 'Stella',
        value: 'aura-stella-en',
        language: 'en'
    },
    {
        label: 'Athena',
        value: 'aura-athena-en',
        language: 'en'
    },
    {
        label: 'Hera',
        value: 'aura-hera-en',
        language: 'en'
    },
    {
        label: 'Orion',
        value: 'aura-orion-en',
        language: 'en'
    },
    {
        label: 'Arcas',
        value: 'aura-arcas-en',
        language: 'en'
    },
    {
        label: 'Perseus',
        value: 'aura-perseus-en',
        language: 'en'
    },
    {
        label: 'Angus',
        value: 'aura-angus-en',
        language: 'en'
    },
    {
        label: 'Orpheus',
        value: 'aura-orpheus-en',
        language: 'en'
    },
    {
        label: 'Helios',
        value: 'aura-helios-en',
        language: 'en'
    },
    {
        label: 'Zeus',
        value: 'aura-zeus-en',
        language: 'en'
    }
];
exports.AWS_POLLY_AVATARS = [
    {
        label: 'Zeina',
        value: 'Zeina',
        gender: 'Female',
        language: 'arb',
        baseLanguage: 'ar'
    },
    {
        label: 'Zhiyu (Mandarin)',
        value: 'Zhiyu',
        gender: 'Female',
        language: 'cmn-CN',
        baseLanguage: 'zh_CN'
    },
    {
        label: 'Naja (Danish)',
        value: 'Naja',
        gender: 'Female',
        language: 'da-DK',
        baseLanguage: 'da'
    },
    {
        label: 'Mads (Danish)',
        value: 'Mads',
        gender: 'Male',
        language: 'da-DK',
        baseLanguage: 'da'
    },
    {
        label: 'Lotte (Dutch)',
        value: 'Lotte',
        gender: 'Female',
        language: 'nl-NL',
        baseLanguage: 'nl'
    },
    {
        label: 'Ruben (Dutch)',
        value: 'Ruben',
        gender: 'Male',
        language: 'nl-NL',
        baseLanguage: 'nl'
    },
    {
        label: 'Nicole (Australian English)',
        value: 'Nicole',
        gender: 'Female',
        language: 'en-AU',
        baseLanguage: 'en'
    },
    {
        label: 'Russell (Australian English)',
        value: 'Russell',
        gender: 'Male',
        language: 'en-AU',
        baseLanguage: 'en'
    },
    {
        label: 'Amy (British English)',
        value: 'Amy',
        gender: 'Female',
        language: 'en-GB',
        baseLanguage: 'en'
    },
    {
        label: 'Emma (British English)',
        value: 'Emma',
        gender: 'Female',
        language: 'en-GB',
        baseLanguage: 'en'
    },
    {
        label: 'Brian (British English)',
        value: 'Brian',
        gender: 'Male',
        language: 'en-GB',
        baseLanguage: 'en'
    },
    {
        label: 'Aditi (Indian English)',
        value: 'Aditi',
        gender: 'Female',
        language: 'en-IN',
        baseLanguage: 'en'
    },
    {
        label: 'Raveena (Indian English)',
        value: 'Raveena',
        gender: 'Female',
        language: 'en-IN',
        baseLanguage: 'en'
    },
    {
        label: 'Ivy (US English)',
        value: 'Ivy',
        gender: 'Female',
        language: 'en-US',
        baseLanguage: 'en'
    },
    {
        label: 'Joanna (US English)',
        value: 'Joanna',
        gender: 'Female',
        language: 'en-US',
        baseLanguage: 'en'
    },
    {
        label: 'Kendra (US English)',
        value: 'Kendra',
        gender: 'Female',
        language: 'en-US',
        baseLanguage: 'en'
    },
    {
        label: 'Kimberly (US English)',
        value: 'Kimberly',
        gender: 'Female',
        language: 'en-US',
        baseLanguage: 'en'
    },
    {
        label: 'Salli (US English)',
        value: 'Salli',
        gender: 'Female',
        language: 'en-US',
        baseLanguage: 'en'
    },
    {
        label: 'Joey (US English)',
        value: 'Joey',
        gender: 'Male',
        language: 'en-US',
        baseLanguage: 'en'
    },
    {
        label: 'Kevin (US English)',
        value: 'Kevin',
        gender: 'Male',
        language: 'en-US',
        baseLanguage: 'en'
    },
    {
        label: 'Geraint (Welsh)',
        value: 'Geraint',
        gender: 'Male',
        language: 'en-GB-WLS',
        baseLanguage: 'cy'
    },
    {
        label: 'Céline/Celine (French)',
        value: 'Celine',
        gender: 'Female',
        language: 'fr-FR',
        baseLanguage: 'fr'
    },
    {
        label: 'Léa (French)',
        value: 'Lea',
        gender: 'Female',
        language: 'fr-FR',
        baseLanguage: 'fr'
    },
    {
        label: 'Mathieu (French)',
        value: 'Mathieu',
        gender: 'Male',
        language: 'fr-FR',
        baseLanguage: 'fr'
    },
    {
        label: 'Chantal (Canadian French)',
        value: 'Chantal',
        gender: 'Female',
        language: 'fr-CA',
        baseLanguage: 'fr'
    },
    {
        label: 'Marlene (German)',
        value: 'Marlene',
        gender: 'Female',
        language: 'de-DE',
        baseLanguage: 'de'
    },
    {
        label: 'Vicki (German)',
        value: 'Vicki',
        gender: 'Female',
        language: 'de-DE',
        baseLanguage: 'de'
    },
    {
        label: 'Hans (German)',
        value: 'Hans',
        gender: 'Male',
        language: 'de-DE',
        baseLanguage: 'de'
    },
    {
        label: 'Aditi (Hindi)',
        value: 'Aditi',
        gender: 'Female',
        language: 'hi-IN',
        baseLanguage: 'hi'
    },
    {
        label: 'Dóra/Dora (Icelandic)',
        value: 'Dora',
        gender: 'Female',
        language: 'is-IS',
        baseLanguage: 'is'
    },
    {
        label: 'Karl (Icelandic)',
        value: 'Karl',
        gender: 'Male',
        language: 'is-IS',
        baseLanguage: 'is'
    },
    {
        label: 'Carla (Italian)',
        value: 'Carla',
        gender: 'Female',
        language: 'it-IT',
        baseLanguage: 'it'
    },
    {
        label: 'Bianca (Italian)',
        value: 'Bianca',
        gender: 'Female',
        language: 'it-IT',
        baseLanguage: 'it'
    },
    {
        label: 'Giorgio (Italian)',
        value: 'Giorgio',
        gender: 'Male',
        language: 'it-IT',
        baseLanguage: 'it'
    },
    {
        label: 'Mizuki (Japanese)',
        value: 'Mizuki',
        gender: 'Female',
        language: 'ja-JP',
        baseLanguage: 'ja'
    },
    {
        label: 'Takumi (Japanese)',
        value: 'Takumi',
        gender: 'Male',
        language: 'ja-JP',
        baseLanguage: 'ja'
    },
    {
        label: 'Seoyeon (Korean)',
        value: 'Seoyeon',
        gender: 'Female',
        language: 'ko-KR',
        baseLanguage: 'ko'
    },
    {
        label: 'Liv (Norwegian)',
        value: 'Liv',
        gender: 'Female',
        language: 'nb-NO',
        baseLanguage: 'nb'
    },
    {
        label: 'Ewa (Polish)',
        value: 'Ewa',
        gender: 'Female',
        language: 'pl-PL',
        baseLanguage: 'pl'
    },
    {
        label: 'Maja (Polish)',
        value: 'Maja',
        gender: 'Female',
        language: 'pl-PL',
        baseLanguage: 'pl'
    },
    {
        label: 'Jacek (Polish)',
        value: 'Jacek',
        gender: 'Male',
        language: 'pl-PL',
        baseLanguage: 'pl'
    },
    {
        label: 'Jan (Polish)',
        value: 'Jan',
        gender: 'Male',
        language: 'pl-PL',
        baseLanguage: 'pl'
    },
    {
        label: 'Camila (Brazilian Portuguese)',
        value: 'Camila',
        gender: 'Female',
        language: 'pt-BR',
        baseLanguage: 'pt'
    },
    {
        label: 'Vitória/Vitoria (Brazilian Portuguese)',
        value: 'Vitoria',
        gender: 'Female',
        language: 'pt-BR',
        baseLanguage: 'pt'
    },
    {
        label: 'Ricardo (Brazilian Portuguese)',
        value: 'Ricardo',
        gender: 'Male',
        language: 'pt-BR',
        baseLanguage: 'pt'
    },
    {
        label: 'Inês/Ines (European Portuguese)',
        value: 'Ines',
        gender: 'Female',
        language: 'pt-PT',
        baseLanguage: 'pt'
    },
    {
        label: 'Cristiano (European Portuguese)',
        value: 'Cristiano',
        gender: 'Male',
        language: 'pt-PT',
        baseLanguage: 'pt'
    },
    {
        label: 'Carmen (Romanian)',
        value: 'Carmen',
        gender: 'Female',
        language: 'ro-RO',
        baseLanguage: 'ro'
    },
    {
        label: 'Tatyana (Russian)',
        value: 'Tatyana',
        gender: 'Female',
        language: 'ru-RU',
        baseLanguage: 'ru'
    },
    {
        label: 'Maxim (Russian)',
        value: 'Maxim',
        gender: 'Male',
        language: 'ru-RU',
        baseLanguage: 'ru'
    },
    {
        label: 'Conchita (European Spanish)',
        value: 'Conchita',
        gender: 'Female',
        language: 'es-ES',
        baseLanguage: 'es'
    },
    {
        label: 'Lucia (European Spanish)',
        value: 'Lucia',
        gender: 'Female',
        language: 'es-ES',
        baseLanguage: 'es'
    },
    {
        label: 'Enrique (European Spanish)',
        value: 'Enrique',
        gender: 'Male',
        language: 'es-ES',
        baseLanguage: 'es'
    },
    {
        label: 'Mia (Mexican Spanish)',
        value: 'Mia',
        gender: 'Female',
        language: 'es-MX',
        baseLanguage: 'es'
    },
    {
        label: 'Lupe (US Spanish)',
        value: 'Lupe',
        gender: 'Female',
        language: 'es-US',
        baseLanguage: 'es'
    },
    {
        label: 'Penélope/Penelope (US Spanish)',
        value: 'Penelope',
        gender: 'Female',
        language: 'es-US',
        baseLanguage: 'es'
    },
    {
        label: 'Miguel (US Spanish)',
        value: 'Miguel',
        gender: 'Male',
        language: 'es-US',
        baseLanguage: 'es'
    },
    {
        label: 'Astrid (Swedish)',
        value: 'Astrid',
        gender: 'Female',
        language: 'sv-SE',
        baseLanguage: 'sv'
    },
    {
        label: 'Filiz (Turkish)',
        value: 'Filiz',
        gender: 'Female',
        language: 'tr-TR',
        baseLanguage: 'tr'
    },
    {
        label: 'Gwyneth (Welsh)',
        value: 'Gwyneth',
        gender: 'Female',
        language: 'cy-GB',
        baseLanguage: 'cy'
    }
];
exports.GOOGLE_TRANSCRIPTION_LANGUAGES = [
    { value: 'en', googleSpeechCode: 'en-US' },
    { value: 'zh_CN', googleSpeechCode: 'zh' },
    { value: 'zh_TW', googleSpeechCode: 'zh-TW' },
    { value: 'pt', googleSpeechCode: 'pt-BR' },
    { value: 'fr', googleSpeechCode: 'fr-FR' },
    { value: 'de', googleSpeechCode: 'de-DE' },
    { value: 'da', googleSpeechCode: 'da-DK' },
    { value: 'nl', googleSpeechCode: 'nl-NL' },
    { value: 'sv', googleSpeechCode: 'sv-SE' },
    { value: 'fi', googleSpeechCode: 'fi-FI' },
    { value: 'nn', googleSpeechCode: 'nb-NO' },
    { value: 'ja', googleSpeechCode: 'ja-JP' },
    { value: 'ko', googleSpeechCode: 'ko-KR' },
    { value: 'vi', googleSpeechCode: 'vi-VN' },
    { value: 'es', googleSpeechCode: 'es-ES' },
    { value: 'ar', googleSpeechCode: 'ar' },
    { value: 'cs', googleSpeechCode: 'cs-CZ' },
    { value: 'he', googleSpeechCode: 'he-IL' },
    { value: 'hi', googleSpeechCode: 'hi-IN' },
    { value: 'hu', googleSpeechCode: 'hu-HU' },
    { value: 'id', googleSpeechCode: 'id-ID' },
    { value: 'sk', googleSpeechCode: 'sk-SK' },
    { value: 'it', googleSpeechCode: 'it-IT' },
    { value: 'tr', googleSpeechCode: 'tr-TR' },
    { value: 'th', googleSpeechCode: 'th-TH' },
    { value: 'tl', googleSpeechCode: 'fil-PH' },
    { value: 'pl', googleSpeechCode: 'pl-PL' },
    { value: 'ru', googleSpeechCode: 'ru-RU' }
];
exports.DEEPGRAM_TRANSCRIPTION_LANGUAGES = [
    'bg',
    'ca',
    'zh',
    'zh-CN',
    'zh-Hans',
    'zh-TW',
    'zh-Hant',
    'cs',
    'da',
    'da-DK',
    'nl',
    'en',
    'en-US',
    'en-AU',
    'en-GB',
    'en-NZ',
    'en-IN',
    'et',
    'fi',
    'nl-BE',
    'fr',
    'fr-CA',
    'de',
    'de-CH',
    'el',
    'hi',
    'hu',
    'id',
    'it',
    'ja',
    'ko',
    'ko-KR',
    'lv',
    'lt',
    'ms',
    'multi',
    'no',
    'pl',
    'pt',
    'pt-BR',
    'ro',
    'ru',
    'sk',
    'es',
    'es-419',
    'sv',
    'sv-SE',
    'th',
    'th-TH',
    'tr',
    'uk',
    'vi' // Vietnamese
];
exports.DEFAULT_INPUT_SETTINGS = {
    voicePlusEnabled: false,
    inputTypes: [types_1.USER_INPUT_TYPE.TEXT, types_1.USER_INPUT_TYPE.FILE_UPLOAD],
    preferredInputType: types_1.USER_INPUT_TYPE.TEXT,
    digitalAvatar: {
        enabled: false,
        streamingAvatarId: exports.DEEPGRAM_AVATARS.find(function (a) { return a.default; }).value,
        provider: types_1.DIGITAL_AVATAR_PROVIDER.DEEPGRAM,
        type: types_1.AVATAR_TYPE.AUDIO
    }
};
exports.DEFAULT_EXPORT_SETTINGS = {
    showURLMetadata: true,
    label: false,
    showall: false,
    reactiontime: false,
    uploads: true,
    originalLanguage: false,
    probeOneColumn: false,
    showSelectionEntry: true,
    showSimplifiedHeaders: true
};
exports.DEFAULT_QUESTION_INPUT_SETTINGS = {
    customInputTypes: false,
    inputTypes: [types_1.USER_INPUT_TYPE.TEXT, types_1.USER_INPUT_TYPE.FILE_UPLOAD],
    preferredInputType: types_1.USER_INPUT_TYPE.TEXT
};
exports.ROLES = {
    ADMIN: 'ADMIN',
    EDITOR: 'EDITOR',
    VIEWER: 'VIEWER',
    COLLABORATOR: 'COLLABORATOR'
};
exports.ACCOUNT_TYPES = {
    //internal
    ADMIN: 'ADMIN',
    ACCOUNT_MANAGER: 'ACCOUNT_MANAGER',
    EDITOR: 'EDITOR',
    VIEWER: 'VIEWER',
    PROJECT_MANAGER: 'PROJECT_MANAGER',
    //external
    GUEST: 'GUEST' // ---> Guest in UI
};
exports.PERMISSIONS = {
    projectCreation: [exports.ROLES.ADMIN, exports.ROLES.EDITOR],
    projectDeleteRole: [exports.ROLES.ADMIN],
    editProjectRole: [exports.ROLES.ADMIN, exports.ROLES.EDITOR],
    publishProjectRole: [exports.ROLES.ADMIN, exports.ROLES.EDITOR],
    modifyStudyRoles: [exports.ROLES.ADMIN, exports.ROLES.EDITOR, exports.ROLES.COLLABORATOR],
    crosstabEditRoles: [exports.ROLES.ADMIN, exports.ROLES.EDITOR, exports.ROLES.COLLABORATOR],
    aicodingModifyRoles: [exports.ROLES.ADMIN, exports.ROLES.EDITOR, exports.ROLES.COLLABORATOR],
    aiCodingcreateRoles: [exports.ROLES.ADMIN, exports.ROLES.EDITOR],
    getCreditsRole: [exports.ROLES.ADMIN, exports.ROLES.EDITOR]
};
exports.CODE_FILE_UPLOAD_PREFIX = 'File uploaded on ';
exports.SENSORY_BOT_POLICY_ID = 'sensory-bot-isa';
exports.SENSORY_BOT_PROJECT_ID = 'ISA_SENSORY_BOT_TEST';
//# sourceMappingURL=constants.js.map